<template>
  <div>
    <CAlert color="warning" closeButton :show.sync="alert">
      {{ alertText }}
    </CAlert>
    <!-- ************************************************ethernet setting -->
    <CForm class="needs-validationEthernetFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showEthernet = showEthernet === 5 ? false : 5"
          >
            <h5 class="text-primary">
              اطلاعات Ethernet<small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ ethernet.updateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showEthernet === 5">
            <CCardBody>
              <CRow>
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="IP"
                  v-model="ethernet.ipAddress"
                  :value="ethernet.ipAddress"
                  maxLength="15"
                />
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="Subnet Mask"
                  v-model="ethernet.subnetMask"
                  :value="ethernet.subnetMask"
                  maxLength="15"
                />
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="Gateway"
                  v-model="ethernet.gateway"
                  :value="ethernet.gateway"
                  maxLength="15"
                />
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="DNS"
                  v-model="ethernet.dns"
                  :value="ethernet.dns"
                  maxLength="15"
                />
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('ethernet')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('ethernet')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                    @click="refreshDeviceSetting('ethernet')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
              </CRow>
              <CRow v-if="spinnerEthernet" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>
    <!-- ************************************************alarm setting setting -->
    <CForm class="needs-validationAlarmFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showVoiceAlarm = showVoiceAlarm === 4 ? false : 4"
          >
            <h5 class="text-primary">
              اطلاعات تایمر آلارم صوتی
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ voiceAlarmInfo.updateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showVoiceAlarm === 4">
            <CCardBody>
              <CRow>
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="تاخیر"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  type="number"
                  maxlength="4"
                  required
                  v-model="voiceAlarmInfo.delay"
                  :value="voiceAlarmInfo.delay"
                />

                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="طول آلارم"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  type="number"
                  maxlength="4"
                  required
                  v-model="voiceAlarmInfo.length"
                  :value="voiceAlarmInfo.length"
                />

                <CInputCheckbox
                  label="آلارم صوتی دما"
                  class="mt-4 mr-2 pt-3 col-sm-12 col-md-6 col-lg-4 px-4"
                  :checked="voiceAlarmInfo.voiceTemp"
                  @change="voiceAlarmInfo.voiceTemp = !voiceAlarmInfo.voiceTemp"
                />
                <CInputCheckbox
                  label="آلارم پیامکی دما"
                  class="mt-4 mr-2 pt-3 col-sm-12 col-md-6 col-lg-4 px-4"
                  :checked="voiceAlarmInfo.smsTemp"
                  @change="voiceAlarmInfo.smsTemp = !voiceAlarmInfo.smsTemp"
                />
                <CInputCheckbox
                  label="آلارم صوتی رطوبت"
                  class="mt-4 mr-2 pt-3 col-sm-12 col-md-6 col-lg-4 px-4"
                  :checked="voiceAlarmInfo.voiceHum"
                  @change="voiceAlarmInfo.voiceHum = !voiceAlarmInfo.voiceHum"
                />
                <CInputCheckbox
                  label="آلارم پیامکی رطوبت"
                  class="mt-4 mr-2 pt-3 col-sm-12 col-md-6 col-lg-4 px-4"
                  :checked="voiceAlarmInfo.smsHum"
                  @change="voiceAlarmInfo.smsHum = !voiceAlarmInfo.smsHum"
                />
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('voiceAlarm')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('voiceAlarm')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                  @click="refreshDeviceSetting('voiceAlarm')"
                  color="warning"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-loop-circular" class="mx-1" />به
                  روزرسانی</CButton
                > -->
              </CRow>
              <CRow
                v-if="spinnerVoiceAlarm"
                class="justify-content-center mt-2"
              >
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>

    <!-- ************************************************log setting setting -->
    <!-- <CForm class="needs-validationLogFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showLog = showLog === 4 ? false : 4"
          >
            <h5 class="text-primary">
              تنظیمات لاگ
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ logInfo.updateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showLog === 4">
            <CCardBody>
              <CRow>
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="فاصله لاگ"
                  type="number"
                  required
                  v-model="logInfo.distance"
                  :value="logInfo.distance"
                />
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('log')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('log')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
               
              </CRow>
              <CRow v-if="spinnerLog" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm> -->

    <!-- ************************************************server setting -->
    <CForm class="needs-validationServerFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showGPRS = showGPRS === 5 ? false : 5"
          >
            <h5 class="text-primary">
              اطلاعات سرور<small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ serverInfo.updateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showGPRS === 5">
            <CCardBody>
              <CRow align-vertical="center">
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="IP Ethernet"
                  v-model="serverInfo.ipAddressEthernet"
                  :value="serverInfo.ipAddressEthernet"
                  maxLength="15"
                  required
                />

                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="IP GPRS"
                  v-model="serverInfo.ipAddressGPRS"
                  :value="serverInfo.ipAddressGPRS"
                  maxLength="15"
                  required
                />
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="IP WiFi"
                  v-model="serverInfo.ipAddressWifi"
                  :value="serverInfo.ipAddressWifi"
                  maxLength="15"
                  required
                />
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="port"
                  v-model="serverInfo.port"
                  :value="serverInfo.port"
                  type="number"
                  required
                />
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="فاصله زمانی"
                  v-model="serverInfo.timeDistance"
                  :value="serverInfo.timeDistance"
                  type="number"
                  required
                />

                <CInputCheckbox
                  label="ethernet"
                  class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                  :checked="serverInfo.ethernet"
                  @change="serverInfo.ethernet = !serverInfo.ethernet"
                />
                <CInputCheckbox
                  label="gprs"
                  class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                  :checked="serverInfo.gprs"
                  @change="serverInfo.gprs = !serverInfo.gprs"
                />
                <CInputCheckbox
                  label="WiFi"
                  class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                  :checked="serverInfo.wifi"
                  @change="serverInfo.wifi = !serverInfo.wifi"
                />

                <CInputCheckbox
                  label="Debug Ethernet"
                  class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                  :checked="serverInfo.debugEth"
                  @change="serverInfo.debugEth = !serverInfo.debugEth"
                />
                <CInputCheckbox
                  label="Debug WiFi"
                  class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                  :checked="serverInfo.debugWifi"
                  @change="serverInfo.debugWifi = !serverInfo.debugWifi"
                />
                <CInputCheckbox
                  label="Debug Gprs"
                  class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                  :checked="serverInfo.debugGprs"
                  @change="serverInfo.debugGprs = !serverInfo.debugGprs"
                />
                <CInputCheckbox
                  label="AT WiFi"
                  class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                  :checked="serverInfo.atWifi"
                  @change="serverInfo.atWifi = !serverInfo.atWifi"
                />
                <CInputCheckbox
                  label="AT Gprs"
                  class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                  :checked="serverInfo.atGprs"
                  @change="serverInfo.atGprs = !serverInfo.atGprs"
                />
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('server')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('server')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                    @click="refreshDeviceSetting('server')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
              </CRow>
              <CRow v-if="spinnerServer" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>

    <!-- ************************************************puls setting -->
    <CForm class="needs-validationPulsFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showPulsAlarm = showPulsAlarm === 6 ? false : 6"
          >
            <h5 class="text-primary">
              اطلاعات نبض
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ pulsInfo.updateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showPulsAlarm === 6">
            <CCardBody>
              <CRow>
                <vue-clock-picker
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="نبض اول"
                  v-model="pulsInfo.first"
                  :value="pulsInfo.first"
                  required
                >
                </vue-clock-picker>
                <vue-clock-picker
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="نبض دوم"
                  v-model="pulsInfo.second"
                  :value="pulsInfo.second"
                  required
                >
                </vue-clock-picker>
              </CRow>
              <CRow class="justify-content-center mt-3">
                <CButton
                  @click="recieveDeviceSetting('puls')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('puls')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                  @click="refreshDeviceSetting('puls')"
                  color="warning"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-loop-circular" class="mx-1" />به
                  روزرسانی</CButton
                > -->
              </CRow>
              <CRow v-if="spinnerPuls" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>

    <!-- ************************************************dateTime setting -->
    <CForm class="needs-validationDateTimeFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showDateTeimeAlarm = showDateTeimeAlarm === 6 ? false : 6"
          >
            <h5 class="text-primary">
              اطلاعات تاریخ و ساعت
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ dateTime.updateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showDateTeimeAlarm === 6">
            <CCardBody>
              <CRow>
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="تاریخ و ساعت"
                  v-model="dateTime.dateTime"
                  :value="dateTime.dateTime"
                  :disabled="true"
                />
              </CRow>
              <CRow class="justify-content-center mt-3">
                <CButton
                  @click="recieveDeviceSetting('dateTime')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('dateTime')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                  @click="refreshDeviceSetting('puls')"
                  color="warning"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-loop-circular" class="mx-1" />به
                  روزرسانی</CButton
                > -->
              </CRow>
              <CRow v-if="spinnerPuls" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>

    <!-- ************************************************simcard setting -->
    <CForm class="needs-validationSimFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showSimcard = showSimcard === 3 ? false : 3"
          >
            <h5 class="text-primary">
              اطلاعات سیم کارت
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ simcardUpdateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showSimcard === 3">
            <CCardBody>
              <CRow>
                <div class="col-sm-12 col-md-6 col-lg-4">
                  <label class="typo__label">اپراتور</label>
                  <multiselect
                    class="needs-validationSimFE22WE"
                    v-model="SimcardOprator"
                    :options="SimcardOpratorList"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    :show-labels="false"
                    placeholder="انتخاب..."
                    label="name"
                    track-by="id"
                    required
                  ></multiselect>
                </div>
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('simcard')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('simcard')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                  @click="refreshDeviceSetting('simcard')"
                  color="warning"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-loop-circular" class="mx-1" />به
                  روزرسانی</CButton
                > -->
              </CRow>
              <CRow v-if="spinnerSimcard" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>

    <!-- ************************************************serialNumber setting -->
    <CRow class="mt-2">
      <CCard class="mb-0 p-0">
        <CButton
          block
          class="text-right shadow-none card-header"
          @click="showSerialNumber = showSerialNumber === 3 ? false : 3"
        >
          <h5 class="text-primary">
            اطلاعات شماره سریال
            <small class="text-secondary mx-3"
              >آخرین به روزرسانی: {{ serial.serialTime }}</small
            >
          </h5>
        </CButton>
        <CCollapse :show="showSerialNumber === 3">
          <CCardBody>
            <CRow>
              <CInput
                class="col-sm-12 col-lg-6"
                label="شماره سریال"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                maxlength="4"
                v-model="serial.serialNumber"
                :value="serial.serialNumber"
              />
            </CRow>
            <CRow class="justify-content-center mt-2">
              <CButton
                @click="recieveDeviceSetting('serial')"
                color="info"
                class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                ><CIcon name="cil-cloud-download" class="mx-1" />دریافت</CButton
              >
              <CButton
                @click="setDeviceSetting('serial')"
                color="success"
                class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
              >
              <!-- <CButton
                  @click="refreshDeviceSetting('simcard')"
                  color="warning"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-loop-circular" class="mx-1" />به
                  روزرسانی</CButton
                > -->
            </CRow>
            <CRow
              v-if="spinnerSerialNumber"
              class="justify-content-center mt-2"
            >
              <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </CRow>
          </CCardBody>
        </CCollapse>
      </CCard>
    </CRow>

    <!-- ************************************************sms setting -->
    <CForm class="needs-validationSmsFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showSmsAlarm = showSmsAlarm === 7 ? false : 7"
          >
            <h5 class="text-primary">
              اطلاعات پیامک- شماره تلفن و نبض
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ smsUpdateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showSmsAlarm === 7">
            <CCardBody>
              <CRow class="mt-2 p-2">
                <table class="table table-striped m-2">
                  <thead>
                    <tr>
                      <th scope="col">ردیف</th>
                      <th scope="col">گیرندگان</th>
                      <th scope="col">شماره تلفن</th>
                      <th scope="col">نبض</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in smsSetting" :key="i">
                      <!-- <th scope="row">{{i+1}}</th> -->
                      <td>{{ i + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td>
                        <CInput
                          type="number"
                          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                          maxlength="11"
                          v-model="smsSetting[i].phoneNumber"
                          :value="smsSetting[i].phoneNumber"
                        />
                      </td>
                      <td>
                        <CInputCheckbox
                          :checked="smsSetting[i].active"
                          @change="smsSetting[i].active = !smsSetting[i].active"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('sms')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('sms')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                    @click="refreshDeviceSetting('sensor')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
              </CRow>
              <CRow v-if="spinnerSms" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>

    <!-- ************************************************smsFlag setting -->
    <CForm class="needs-validationSmsFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showSmsAlarmFlag = showSmsAlarmFlag === 7 ? false : 7"
          >
            <h5 class="text-primary">
              اطلاعات پیامک- دما/رطوبت/قطعی/برق/پیامک
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ smsUpdateTimeFlag }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showSmsAlarmFlag === 7">
            <CCardBody>
              <CRow class="mt-2 p-2">
                <table class="table table-striped m-2">
                  <thead>
                    <tr>
                      <th scope="col">ردیف</th>
                      <th scope="col">گیرندگان</th>

                      <th scope="col">دما/رطوبت</th>
                      <th scope="col">قطعی</th>
                      <th scope="col">برق</th>

                      <th scope="col">پیامک فارسی</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in smsSetting" :key="i">
                      <!-- <th scope="row">{{i+1}}</th> -->
                      <td>{{ i + 1 }}</td>
                      <td>{{ item.name }}</td>

                      <td>
                        <CInputCheckbox
                          :checked="smsSetting[i].tempHum"
                          @change="
                            smsSetting[i].tempHum = !smsSetting[i].tempHum
                          "
                        />
                      </td>

                      <td>
                        <CInputCheckbox
                          :checked="smsSetting[i].disconnect"
                          @change="
                            smsSetting[i].disconnect = !smsSetting[i].disconnect
                          "
                        />
                      </td>

                      <td>
                        <CInputCheckbox
                          :checked="smsSetting[i].power"
                          @change="smsSetting[i].power = !smsSetting[i].power"
                        />
                      </td>

                      <td>
                        <CInputCheckbox
                          :checked="smsSetting[i].text"
                          @change="smsSetting[i].text = !smsSetting[i].text"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('smsFlag')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('smsFlag')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                    @click="refreshDeviceSetting('sensor')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
              </CRow>
              <CRow v-if="spinnerSmsFlag" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>

    <!-- ************************************************smsDelay setting -->
    <CForm class="needs-validationSmsFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showSmsAlarmDelay = showSmsAlarmDelay === 7 ? false : 7"
          >
            <h5 class="text-primary">
              اطلاعات پیامک- تاخیر پیامک
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ smsUpdateTimeDelay }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showSmsAlarmDelay === 7">
            <CCardBody>
              <CRow class="mt-2 p-2">
                <table class="table table-striped m-2">
                  <thead>
                    <tr>
                      <th scope="col">ردیف</th>
                      <th scope="col">گیرندگان</th>

                      <th scope="col">تاخیر پیامک اول</th>
                      <th scope="col">تاخیر پیامک بعدی</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in smsSetting" :key="i">
                      <!-- <th scope="row">{{i+1}}</th> -->
                      <td>{{ i + 1 }}</td>
                      <td>{{ item.name }}</td>

                      <td>
                        <CInput
                          type="number"
                          v-model="smsSetting[i].firstSmsDelay"
                          :value="smsSetting[i].firstSmsDelay"
                        />
                      </td>
                      <td>
                        <CInput
                          type="number"
                          v-model="smsSetting[i].secondSmsDelay"
                          :value="smsSetting[i].secondSmsDelay"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('smsDelay')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('smsDelay')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                    @click="refreshDeviceSetting('sensor')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
              </CRow>
              <CRow v-if="spinnerSmsDelay" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>

    <!-- ************************************************sensor Temp Hum setting -->
    <CForm class="needs-validationsensorTempHumFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showSensor = showSensor === 1 ? false : 1"
          >
            <h5 class="text-primary">
              تنظیمات سنسور- پیامک دما
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ sensorTempHumUpdateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showSensor === 1">
            <CCardBody>
              <CRow>
                <div class="col-sm-12 col-md-6 col-lg-4">
                  <label class="typo__label">شماره سنسور</label>
                  <multiselect
                    class="needs-validationSensorFE22WE"
                    v-model="sensorSetting.sensorIndex"
                    :options="indexListSensor"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    :show-labels="false"
                    placeholder="انتخاب..."
                    label="label"
                    track-by="value"
                    @select="
                      refreshDeviceSetting(
                        'sensorTempHum',
                        deviceId,
                        $event.value
                      )
                    "
                  ></multiselect></div
              ></CRow>

              <table class="table table-striped m-2">
                <thead>
                  <tr>
                    <th scope="col">ردیف</th>
                    <th scope="col">گیرندگان</th>
                    <th scope="col">پیامک دما بالا</th>
                    <th scope="col">پیامک دما پایین</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in sensorTempHumSetting" :key="i">
                    <!-- <th scope="row">{{i+1}}</th> -->
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.name }}</td>
                    <td>
                      <CInput
                        type="number"
                        v-model="sensorTempHumSetting[i].tempUp"
                        :value="sensorTempHumSetting[i].tempUp"
                      />
                    </td>
                    <td>
                      <CInput
                        type="number"
                        v-model="sensorTempHumSetting[i].tempDown"
                        :value="sensorTempHumSetting[i].tempDown"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('sensorTempHum')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('sensorTempHum')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                    @click="refreshDeviceSetting('wifi')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
              </CRow>
              <CRow
                v-if="spinnerSensorTempHum"
                class="justify-content-center mt-2"
              >
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>

    <!-- ************************************************sensor Temp Hum setting -->
    <CForm class="needs-validationsensorTempHumFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showSensorHum = showSensorHum === 1 ? false : 1"
          >
            <h5 class="text-primary">
              تنظیمات سنسور- پیامک رطوبت
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ sensorTempHumUpdateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showSensorHum === 1">
            <CCardBody>
              <CRow>
                <div class="col-sm-12 col-md-6 col-lg-4">
                  <label class="typo__label">شماره سنسور</label>
                  <multiselect
                    class="needs-validationSensorFE22WE"
                    v-model="sensorSetting.sensorIndex"
                    :options="indexListSensor"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    :show-labels="false"
                    placeholder="انتخاب..."
                    label="label"
                    track-by="value"
                    @select="
                      refreshDeviceSetting(
                        'sensorTempHum',
                        deviceId,
                        $event.value
                      )
                    "
                  ></multiselect></div
              ></CRow>

              <table class="table table-striped m-2">
                <thead>
                  <tr>
                    <th scope="col">ردیف</th>
                    <th scope="col">گیرندگان</th>

                    <th scope="col">پیامک رطوبت بالا</th>
                    <th scope="col">پیامک رطوبت پایین</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in sensorTempHumSetting" :key="i">
                    <!-- <th scope="row">{{i+1}}</th> -->
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.name }}</td>

                    <td>
                      <CInput
                        type="number"
                        v-model="sensorTempHumSetting[i].humUp"
                        :value="sensorTempHumSetting[i].humUp"
                      />
                    </td>
                    <td>
                      <CInput
                        type="number"
                        v-model="sensorTempHumSetting[i].humDwon"
                        :value="sensorTempHumSetting[i].humDwon"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('sensorTempHum_hum')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('sensorTempHum_hum')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                    @click="refreshDeviceSetting('wifi')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
              </CRow>
              <CRow
                v-if="spinnerSensorTempHum_hum"
                class="justify-content-center mt-2"
              >
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>

    <!-- ************************************************sensor setting -->
    <CForm class="needs-validationSensorFE22WE" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showSensorAlarm = showSensorAlarm === 8 ? false : 8"
          >
            <h5 class="text-primary">
              اطلاعات سنسور- رله/آلارم
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ sensorRelayAlarmUpdateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showSensorAlarm === 8">
            <CCardBody>
              <CRow>
                <div class="col-sm-12 col-md-6 col-lg-4">
                  <label class="typo__label">شماره سنسور</label>
                  <multiselect
                    class="needs-validationSensorFE22WE"
                    v-model="sensorSetting.sensorIndex"
                    :options="indexListSensor"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    :show-labels="false"
                    placeholder="انتخاب..."
                    label="label"
                    track-by="value"
                    @select="
                      refreshDeviceSetting('sensor', deviceId, $event.value)
                    "
                  ></multiselect></div
              ></CRow>

              <h5 class="text-primary mt-3">تنظیمات</h5>
              <hr />
              <CRow class="mt-1">
                <div class="col-sm-12 col-md-6 col-lg-4">
                  <label class="typo__label">نوع سنسور</label>
                  <multiselect
                    class="needs-validationSensorFE22WE"
                    v-model="sensorSetting.type"
                    :options="typeList"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    :show-labels="false"
                    placeholder="انتخاب..."
                    label="label"
                    track-by="value"
                  ></multiselect>
                </div>
                <CInputCheckbox
                  label="فعال"
                  class="mt-4 mr-2 pt-3 col-sm-12 col-md-6 col-lg-4 px-4"
                  :checked="sensorSetting.active"
                  @change="sensorSetting.active = !sensorSetting.active"
                />
              </CRow>
              <CRow class="mt-2 p-2">
                <table class="table table-striped m-2">
                  <thead>
                    <tr>
                      <th scope="col">ردیف</th>
                      <th scope="col">سنسور</th>
                      <th scope="col">رله-بالا</th>
                      <th scope="col">رله پایین</th>
                      <th scope="col">آلارم-بالا</th>
                      <th scope="col">آلارم-پایین</th>
                      <th scope="col">کالیبراسیون</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, i) in sensorSetting.alarmRelay"
                      :key="item.name + i"
                    >
                      <!-- <th scope="row">{{i+1}}</th> -->
                      <td>{{ i + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td>
                        <CInput
                          type="number"
                          v-model="sensorSetting.alarmRelay[i].relayUp"
                          :value="sensorSetting.alarmRelay[i].relayUp"
                        />
                      </td>
                      <td>
                        <CInput
                          type="number"
                          v-model="sensorSetting.alarmRelay[i].relayDown"
                          :value="sensorSetting.alarmRelay[i].relayDown"
                        />
                      </td>
                      <td>
                        <CInput
                          type="number"
                          v-model="sensorSetting.alarmRelay[i].alarmUp"
                          :value="sensorSetting.alarmRelay[i].alarmUp"
                        />
                      </td>
                      <td>
                        <CInput
                          type="number"
                          v-model="sensorSetting.alarmRelay[i].alarmDown"
                          :value="sensorSetting.alarmRelay[i].alarmDown"
                        />
                      </td>
                      <td>
                        <CInput
                          type="number"
                          v-model="sensorSetting.alarmRelay[i].collibrartion"
                          :value="sensorSetting.alarmRelay[i].collibrartion"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('sensor')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('sensor')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                    @click="refreshDeviceSetting('sensor')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
              </CRow>
              <CRow v-if="spinnerSensor" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>

    <!-- *********************************************** alarm Setting -->
    <CForm class="needs-validationWebAlarm" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showAlarm = showAlarm === 7 ? false : 7"
          >
            <h5 class="text-primary">
              آلارم سنسور- وب
              <!-- <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ alarmUpdateTime }}</small
              > -->
            </h5>
          </CButton>
          <CCollapse :show="showAlarm === 7">
            <CCardBody>
              <CRow class="mt-2 p-2">
                <table class="table table-striped m-2">
                  <thead>
                    <tr>
                      <th scope="col">ردیف</th>
                      <th scope="col">سنسور</th>
                      <th scope="col">بیشینه</th>
                      <th scope="col">کمینه</th>
                      <th scope="col">دوره آلارم</th>
                      <th scope="col">کالیبراسیون</th>
                      <th scope="col">فعال بودن آلارم</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in alarmMinMax" :key="i">
                      <!-- <th scope="row">{{i+1}}</th> -->
                      <td>{{ i + 1 }}</td>
                      <td>{{ item.sensorName }}</td>
                      <td>
                        <CInput
                          type="number"
                          required
                          v-model="item.alarmMax"
                          :value="item.alarmMax"
                        />
                      </td>

                      <td>
                        <CInput
                          type="number"
                          required
                          v-model="item.alarmMin"
                          :value="item.alarmMin"
                        />
                      </td>
                      <td>
                        <CInput
                          type="number"
                          required
                          v-model="item.alarmTime"
                          :value="item.alarmTime"
                        />
                      </td>
                      <td>
                        <CInput
                          type="number"
                          required
                          v-model="item.calibration"
                          :value="item.calibration"
                        />
                      </td>
                      <td>
                        <CInputCheckbox
                          :checked="item.alarmActive"
                          @change="item.alarmActive = !item.alarmActive"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="getSensors(deviceId)"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setSensors()"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                    @click="refreshDeviceSetting('sensor')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>
  </div>
</template>

<script>
import axios from "axios";
import { Values } from "../../commonValues";
import $ from "jquery";
import VueClockPicker from "@pencilpix/vue2-clock-picker";
import Multiselect from "vue-multiselect";

export default {
  props: ["deviceId"],
  components: {
    VueClockPicker,
    Multiselect,
  },
  data() {
    return {
      spinnerEthernet: false,

      spinnerVoiceAlarm: false,
      spinnerLog: false,

      spinnerServer: false,
      spinnerPuls: false,
      spinnerSimcard: false,
      spinnerSms: false,
      spinnerSmsFlag: false,
      spinnerSmsDelay: false,
      spinnerSensorTempHum: false,
      spinnerSensor: false,
      spinnerSensorTempHum_hum: false,
      spinnerSerialNumber: false,

      showAlarm: 1,
      alarmMinMax: [],

      ethernet: {
        ipAddress: "",
        subnetMask: "",
        gateway: "",
        dns: "",
        updateTime: "---",
      },

      sensor: {
        tempMin: "",
        tempMax: "",
        humMin: "",
        humMax: "",
        updateTime: "",
      },

      showSensor: 0,
      showVoiceAlarm: 0,
      showGPRS: 0,
      showPulsAlarm: 0,
      showSimcard: 0,
      showSmsAlarm: 0,
      showSmsAlarmFlag: 0,
      showSmsAlarmDelay: 0,
      showSensorAlarm: 0,
      showEthernet: 0,
      showLog: 0,
      showSerialNumber: 0,
      showDateTeimeAlarm: 0,
      showSensorHum: 0,

      serial: { serialTime: "", serialNumber: "" },

      alert: false,
      alertText: "",

      logInfo: { distance: "", updateTime: "---" },

      voiceAlarmInfo: {
        delay: "",
        length: "",
        voiceTemp: false,
        smsTemp: false,
        voiceHum: false,
        smsHum: false,
        updateTime: "---",
      },

      serverInfo: {
        ipAddressGPRS: "",
        ipAddressEthernet: "",
        ipAddressWifi: "",
        port: "",
        timeDistance: "",
        debugEth: false,
        debugWifi: false,
        debugGprs: false,
        ethernet: false,
        gprs: false,
        wifi: false,
        updateTime: "---",
        atWifi: false,
        atGprs: false,
      },

      pulsInfo: {
        first: "",
        second: "",
        updateTime: "---",
      },

      dateTime: { dateTime: "", updateTime: "" },

      SimcardOpratorList: [
        { name: "همراه اول", id: 1 },
        { name: "ایرانسل", id: 2 },
        { name: "سایر", id: 0 },
      ],
      SimcardOprator: [],
      simcardUpdateTime: "---",

      smsSetting: [
        {
          name: "گیرنده اول",
          phoneNumber: "",
          active: false,
          text: false,
          tempHum: false,
          disconnect: false,
          power: false,
          firstSmsDelay: 0,
          secondSmsDelay: 0,
        },
        {
          name: "گیرنده دوم",
          phoneNumber: "",
          active: false,
          text: false,
          tempHum: false,
          disconnect: false,
          power: false,
          firstSmsDelay: 0,
          secondSmsDelay: 0,
        },

        {
          name: "گیرنده سوم",
          phoneNumber: "",
          active: false,
          text: false,
          tempHum: false,
          disconnect: false,
          power: false,
          firstSmsDelay: 0,
          secondSmsDelay: 0,
        },
        {
          name: "گیرنده چهارم",
          phoneNumber: "",
          active: false,
          text: false,
          tempHum: false,
          disconnect: false,
          power: false,
          firstSmsDelay: 0,
          secondSmsDelay: 0,
        },
        {
          name: "گیرنده پنجم",
          phoneNumber: "",
          active: false,
          text: false,
          tempHum: false,
          disconnect: false,
          power: false,
          firstSmsDelay: 0,
          secondSmsDelay: 0,
        },
        {
          name: "گیرنده ششم",
          phoneNumber: "",
          active: false,
          text: false,
          tempHum: false,
          disconnect: false,
          power: false,
          firstSmsDelay: 0,
          secondSmsDelay: 0,
        },
      ],
      smsUpdateTime: "---",
      smsUpdateTimeFlag: "---",
      smsUpdateTimeDelay: "---",

      sensorTempHumSetting: [
        {
          name: "گیرنده اول",
          tempUp: null,
          tempDown: null,
          humUp: null,
          humDwon: null,
        },
        {
          name: "گیرنده دوم",
          tempUp: null,
          tempDown: null,
          humUp: null,
          humDwon: null,
        },
        {
          name: "گیرنده سوم",
          tempUp: null,
          tempDown: null,
          humUp: null,
          humDwon: null,
        },
        {
          name: "گیرنده چهارم",
          tempUp: null,
          tempDown: null,
          humUp: null,
          humDwon: null,
        },
        {
          name: "گیرنده پنجم",
          tempUp: null,
          tempDown: null,
          humUp: null,
          humDwon: null,
        },
        {
          name: "گیرنده ششم",
          tempUp: null,
          tempDown: null,
          humUp: null,
          humDwon: null,
        },
      ],
      sensorTempHumUpdateTime: "---",

      sensorSetting: {
        sensorIndex: { label: "سنسور اول", value: 1 },
        active: false,
        type: [],
        alarmRelay: [
          {
            name: "دما",
            type: 1,
            relayUp: "",
            relayDown: "",
            alarmUp: "",
            alarmDown: "",
            collibrartion: "",
          },
          {
            name: "روطوبت",
            type: 2,
            relayUp: "",
            relayDown: "",
            alarmUp: "",
            alarmDown: "",
            collibrartion: "",
          },
        ],
      },
      sensorRelayAlarmUpdateTime: "---",

      typeList: [
        { label: "LPTO", value: "1" },
        { label: "HPTO", value: "10" },
        { label: "HPTH", value: "11" },
      ],

      indexListSensor: [
        { label: "سنسور اول", value: 1 },
        { label: "سنسور دوم", value: 2 },
      ],

      ipformat:
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      mobileFormat: /^(09(0[1-2]|1[0-9]|3[0-9]|2[0-1])-?[0-9]{3}-?[0-9]{4})$/,
      emailFormat: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    };
  },

  mounted() {},

  methods: {
    //********************************************************************* recieve sensor data */
    getSensors(data) {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(Values.serverIp + "Sensor/GetSensorsAlarmWebUi", data, config)
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);
            this.alarmMinMax = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },
    //********************************************************************* recieve sensor data */
    setSensors() {
      var forms = document.querySelectorAll(".needs-validationWebAlarm");
      let formValid = true;

      for (var i = 0; i < forms[0].length; i++) {
        if (
          forms[0][i].type == "text" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "number" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "select-one" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "text" &&
          !forms[0][i].value.match(this.ipformat) &&
          !forms[0][i].value.length == 0 &&
          forms[0][i].maxLength == 15
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        }
      }
      if (formValid == true) {
        const config = { headers: { "Content-Type": "application/json" } };
        for (var i = 0; i < this.alarmMinMax.length; i++) {
          if (this.alarmMinMax[i].alarmMax == "")
            this.alarmMinMax[i].alarmMax = null;
          if (this.alarmMinMax[i].alarmMin == "")
            this.alarmMinMax[i].alarmMin = null;
          if (this.alarmMinMax[i].alarmTime == "")
            this.alarmMinMax[i].alarmTime = 0;
          if (this.alarmMinMax[i].calibration == "")
            this.alarmMinMax[i].calibration = 0;
        }
        axios
          .post(
            Values.serverIp + "Sensor/UpdateSensorsAlarmWeb",
            this.alarmMinMax,
            config
          )
          .then((response) => {
            if (response.status == 200) {
              console.log(response.data);
              if (response.data == 0) {
                this.$emit("update", 1);
              } else {
                this.$emit("update", 2);
              }
            }
          })
          .catch((response) => {
            if (response.status != 200) {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
              (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            }
          });
      } else {
        this.alert = true;
        this.alertText = "لطفا تمامی موارد الزامی را وارد نمایید.";
      }
    },
    //   *********************************************************************set Device Setting
    setDeviceSetting(data) {
      if (data == "ethernet") {
        var forms = document.querySelectorAll(
          ".needs-validationEthernetFE22WE"
        );
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        // if (this.info.status.value == "") {
        //   $(".needs-validation > .multiselect__tags").css(
        //     "border-color",
        //     "red"
        //   );
        //   formValid = false;
        // }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerEthernet = true;
          axios
            .post(Values.serverIp + "FE22WEDeviceSetting/SetEthernetSetting", {
              deviceId: this.deviceId,

              //ethernet
              ehtrIpAddress: this.ethernet.ipAddress,
              ehtrMask: this.ethernet.subnetMask,
              ehtrGateway: this.ethernet.gateway,
              ehtrDns: this.ethernet.dns,
            })
            .then((response) => {
              this.spinnerEthernet = false;

              console.log(response.data);

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerEthernet = false;

              console.log(error);
            });
        }
      } else if (data == "voiceAlarm") {
        var forms = document.querySelectorAll(".needs-validationAlarmFE22WE");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        // if (this.info.status.value == "") {
        //   $(".needs-validation > .multiselect__tags").css(
        //     "border-color",
        //     "red"
        //   );
        //   formValid = false;
        // }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerVoiceAlarm = true;

          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/SetAlarmTimerSetting",
              {
                deviceId: this.deviceId,
                //voice alarm
                alarmDelay: this.voiceAlarmInfo.delay,
                alarmDuration: this.voiceAlarmInfo.length,
                temperatureSoundAlarm: this.voiceAlarmInfo.voiceTemp,
                temperatureSmsAlarm: this.voiceAlarmInfo.smsTemp,
                humiditySoundAlarm: this.voiceAlarmInfo.voiceHum,
                humiditySmsAlarm: this.voiceAlarmInfo.smsHum,
              }
            )
            .then((response) => {
              this.spinnerVoiceAlarm = false;

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerVoiceAlarm = false;

              console.log(error);
            });
        }
      } else if (data == "log") {
        var forms = document.querySelectorAll(".needs-validationLogFE22WE");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        // if (this.info.status.value == "") {
        //   $(".needs-validation > .multiselect__tags").css(
        //     "border-color",
        //     "red"
        //   );
        //   formValid = false;
        // }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerLog = true;

          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/SetStartupDelaySetting",
              {
                deviceId: this.deviceId,
                //voice alarm
                RefrigeratorStartupDelayInSeconds: this.logInfo.distance,
              }
            )
            .then((response) => {
              this.spinnerLog = false;

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerLog = false;

              console.log(error);
            });
        }
      } else if (data == "server") {
        var forms = document.querySelectorAll(".needs-validationServerFE22WE");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        // if (this.info.status.value == "") {
        //   $(".needs-validation > .multiselect__tags").css(
        //     "border-color",
        //     "red"
        //   );
        //   formValid = false;
        // }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerServer = true;

          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/SetWebServiceSetting",
              {
                deviceId: this.deviceId,
                //server Ip
                webServiceEthernetAddressIp: this.serverInfo.ipAddressEthernet,
                webServiceUdpPort: this.serverInfo.port,
                webBeatPeriodInSeconds: this.serverInfo.timeDistance,
                wifiDebug: this.serverInfo.debugWifi,
                GprsDebaug: this.serverInfo.debugGprs,
                systemDebug: this.serverInfo.debugSystem,
                gprsBeat: this.serverInfo.gprs,
                wifiBeat: this.serverInfo.wifi,
                wifiAT: this.serverInfo.atWifi,
                gprsAT: this.serverInfo.atGprs,
                ethernetBeat: this.serverInfo.ethernet,
                webServiceGprsAddressIp: this.serverInfo.ipAddressGPRS,
                webServiceWifiAddressIp: this.serverInfo.ipAddressWifi,

                // webServiceUdpPort: this.serverInfo.port,
                // webBeatPeriodInSeconds: this.serverInfo.timeDistance,
                // GsmDebug: this.serverInfo.debugGsm,
              }
            )
            .then((response) => {
              this.spinnerServer = false;

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerServer = false;

              console.log(error);
            });
        }
      } else if (data == "puls") {
        var forms = document.querySelectorAll(".needs-validationPulsFE22WE");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        // if (this.info.status.value == "") {
        //   $(".needs-validation > .multiselect__tags").css(
        //     "border-color",
        //     "red"
        //   );
        //   formValid = false;
        // }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerPuls = true;

          axios
            .post(Values.serverIp + "FE22WEDeviceSetting/SetBeatSetting", {
              deviceId: this.deviceId,

              //puls
              firstBeatTime: this.pulsInfo.first,
              secondBeatTime: this.pulsInfo.second,
            })
            .then((response) => {
              this.spinnerPuls = false;

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerPuls = false;
              console.log(error);
            });
        }
      } else if (data == "dateTime") {
        this.spinnerPuls = true;

        axios
          .post(Values.serverIp + "FE22WEDeviceSetting/SetDateTimeSetting", {
            deviceId: this.deviceId,
          })
          .then((response) => {
            this.spinnerPuls = false;

            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.$emit("update", 1);
              } else if (response.data == 2) {
                this.$emit("update", 2);
              } else if (response.data == 3) {
                this.$emit("update", 3);
              } else if (response.data == 4) {
                this.$emit("update", 4);
              }
            } else {
              this.$emit("update", 2);
            }
          })
          .catch((error) => {
            this.spinnerPuls = false;

            console.log(error);
          });
      } else if (data == "simcard") {
        var forms = document.querySelectorAll(".needs-validationSimFE22WE");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        if (this.SimcardOprator.length == 0) {
          $(".needs-validationSimFE22WE > .multiselect__tags").css(
            "border-color",
            "red"
          );
          formValid = false;
        }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerSimcard = true;

          axios
            .post(Values.serverIp + "FE22WEDeviceSetting/SetSimCardSetting", {
              deviceId: this.deviceId,

              // //simcard
              simCardTypeOperator: this.SimcardOprator.id,
            })
            .then((response) => {
              this.spinnerSimcard = false;

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSimcard = false;

              console.log(error);
            });
        }
      } else if (data == "serial") {
        if (this.serial.serialNumber.length < 4) {
          this.alert = true;
          this.alertText = "شماره سریال باید چهار رقم باشد.";
        } else {
          this.spinnerSerialNumber = true;
          axios
            .post(Values.serverIp + "FE22WEDeviceSetting/SetSystemIdSetting", {
              deviceId: this.deviceId,
              // //simcard
              systemId: this.serial.serialNumber,
            })
            .then((response) => {
              this.spinnerSerialNumber = false;

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSerialNumber = false;

              console.log(error);
            });
        }
      } else if (data == "sms") {
        var forms = document.querySelectorAll(".needs-validationSmsFE22WE");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerSms = true;
          console.log(this.smsSetting);
          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/SetSmsReceiversSetting",
              {
                deviceId: this.deviceId,

                // //simcard
                receiver1SimCartNumber: this.smsSetting[0].phoneNumber,
                receiver1Beat: this.smsSetting[0].active,

                receiver1SmsText: this.smsSetting[0].text,
                receiver1FirstAlarmSmsTimer: this.smsSetting[0].firstSmsDelay,
                receiver1NextAlarmSmsTimer: this.smsSetting[0].secondSmsDelay,
                receiver1SmsT_H: this.smsSetting[0].tempHum,
                receiver1SmsBeat: this.smsSetting[0].disconnect,
                receiver1SmsPower: this.smsSetting[0].power,

                receiver2SimCartNumber: this.smsSetting[1].phoneNumber,
                receiver2Beat: this.smsSetting[1].active,

                receiver2SmsText: this.smsSetting[1].text,
                receiver2FirstAlarmSmsTimer: this.smsSetting[1].firstSmsDelay,
                receiver2NextAlarmSmsTimer: this.smsSetting[1].secondSmsDelay,
                receiver2SmsT_H: this.smsSetting[1].tempHum,
                receiver2SmsBeat: this.smsSetting[1].disconnect,
                receiver2SmsPower: this.smsSetting[1].power,

                receiver3SimCartNumber: this.smsSetting[2].phoneNumber,
                receiver3Beat: this.smsSetting[2].active,

                receiver3SmsText: this.smsSetting[2].text,
                receiver3FirstAlarmSmsTimer: this.smsSetting[2].firstSmsDelay,
                receiver3NextAlarmSmsTimer: this.smsSetting[2].secondSmsDelay,
                receiver3SmsT_H: this.smsSetting[2].tempHum,
                receiver3SmsBeat: this.smsSetting[2].disconnect,
                receiver3SmsPower: this.smsSetting[2].power,

                receiver4SimCartNumber: this.smsSetting[3].phoneNumber,
                receiver4Beat: this.smsSetting[3].active,

                receiver4SmsText: this.smsSetting[3].text,
                receiver4FirstAlarmSmsTimer: this.smsSetting[3].firstSmsDelay,
                receiver4NextAlarmSmsTimer: this.smsSetting[3].secondSmsDelay,
                receiver4SmsT_H: this.smsSetting[3].tempHum,
                receiver4SmsBeat: this.smsSetting[3].disconnect,
                receiver4SmsPower: this.smsSetting[3].power,

                receiver5SimCartNumber: this.smsSetting[4].phoneNumber,
                receiver5Beat: this.smsSetting[4].active,

                receiver5SmsText: this.smsSetting[4].text,
                receiver5FirstAlarmSmsTimer: this.smsSetting[4].firstSmsDelay,
                receiver5NextAlarmSmsTimer: this.smsSetting[4].secondSmsDelay,
                receiver5SmsT_H: this.smsSetting[4].tempHum,
                receiver5SmsBeat: this.smsSetting[4].disconnect,
                receiver5SmsPower: this.smsSetting[4].power,

                receiver6SimCartNumber: this.smsSetting[5].phoneNumber,
                receiver6Beat: this.smsSetting[5].active,

                receiver6SmsText: this.smsSetting[5].text,
                receiver6FirstAlarmSmsTimer: this.smsSetting[5].firstSmsDelay,
                receiver6NextAlarmSmsTimer: this.smsSetting[5].secondSmsDelay,
                receiver6SmsT_H: this.smsSetting[5].tempHum,
                receiver6SmsBeat: this.smsSetting[5].disconnect,
                receiver6SmsPower: this.smsSetting[5].power,
              }
            )
            .then((response) => {
              this.spinnerSms = false;

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSms = false;

              console.log(error);
            });
        }
      } else if (data == "smsFlag") {
        var forms = document.querySelectorAll(".needs-validationSmsFE22WE");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerSms = true;
          console.log(this.smsSetting);
          axios
            .post(
              Values.serverIp +
                "FE22WEDeviceSetting/SetSmsReceiversMessageTextFlagSetting",
              {
                deviceId: this.deviceId,

                // //simcard
                receiver1SimCartNumber: this.smsSetting[0].phoneNumber,
                receiver1Beat: this.smsSetting[0].active,

                receiver1SmsText: this.smsSetting[0].text,
                receiver1FirstAlarmSmsTimer: this.smsSetting[0].firstSmsDelay,
                receiver1NextAlarmSmsTimer: this.smsSetting[0].secondSmsDelay,
                receiver1SmsT_H: this.smsSetting[0].tempHum,
                receiver1SmsBeat: this.smsSetting[0].disconnect,
                receiver1SmsPower: this.smsSetting[0].power,

                receiver2SimCartNumber: this.smsSetting[1].phoneNumber,
                receiver2Beat: this.smsSetting[1].active,

                receiver2SmsText: this.smsSetting[1].text,
                receiver2FirstAlarmSmsTimer: this.smsSetting[1].firstSmsDelay,
                receiver2NextAlarmSmsTimer: this.smsSetting[1].secondSmsDelay,
                receiver2SmsT_H: this.smsSetting[1].tempHum,
                receiver2SmsBeat: this.smsSetting[1].disconnect,
                receiver2SmsPower: this.smsSetting[1].power,

                receiver3SimCartNumber: this.smsSetting[2].phoneNumber,
                receiver3Beat: this.smsSetting[2].active,

                receiver3SmsText: this.smsSetting[2].text,
                receiver3FirstAlarmSmsTimer: this.smsSetting[2].firstSmsDelay,
                receiver3NextAlarmSmsTimer: this.smsSetting[2].secondSmsDelay,
                receiver3SmsT_H: this.smsSetting[2].tempHum,
                receiver3SmsBeat: this.smsSetting[2].disconnect,
                receiver3SmsPower: this.smsSetting[2].power,

                receiver4SimCartNumber: this.smsSetting[3].phoneNumber,
                receiver4Beat: this.smsSetting[3].active,

                receiver4SmsText: this.smsSetting[3].text,
                receiver4FirstAlarmSmsTimer: this.smsSetting[3].firstSmsDelay,
                receiver4NextAlarmSmsTimer: this.smsSetting[3].secondSmsDelay,
                receiver4SmsT_H: this.smsSetting[3].tempHum,
                receiver4SmsBeat: this.smsSetting[3].disconnect,
                receiver4SmsPower: this.smsSetting[3].power,

                receiver5SimCartNumber: this.smsSetting[4].phoneNumber,
                receiver5Beat: this.smsSetting[4].active,

                receiver5SmsText: this.smsSetting[4].text,
                receiver5FirstAlarmSmsTimer: this.smsSetting[4].firstSmsDelay,
                receiver5NextAlarmSmsTimer: this.smsSetting[4].secondSmsDelay,
                receiver5SmsT_H: this.smsSetting[4].tempHum,
                receiver5SmsBeat: this.smsSetting[4].disconnect,
                receiver5SmsPower: this.smsSetting[4].power,

                receiver6SimCartNumber: this.smsSetting[5].phoneNumber,
                receiver6Beat: this.smsSetting[5].active,

                receiver6SmsText: this.smsSetting[5].text,
                receiver6FirstAlarmSmsTimer: this.smsSetting[5].firstSmsDelay,
                receiver6NextAlarmSmsTimer: this.smsSetting[5].secondSmsDelay,
                receiver6SmsT_H: this.smsSetting[5].tempHum,
                receiver6SmsBeat: this.smsSetting[5].disconnect,
                receiver6SmsPower: this.smsSetting[5].power,
              }
            )
            .then((response) => {
              this.spinnerSms = false;

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSms = false;

              console.log(error);
            });
        }
      } else if (data == "smsDelay") {
        var forms = document.querySelectorAll(".needs-validationSmsFE22WE");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerSms = true;
          console.log(this.smsSetting);
          axios
            .post(
              Values.serverIp +
                "FE22WEDeviceSetting/SetSmsReceiversSensorsAlarmTimerSetting",
              {
                deviceId: this.deviceId,

                // //simcard
                receiver1SimCartNumber: this.smsSetting[0].phoneNumber,
                receiver1Beat: this.smsSetting[0].active,

                receiver1SmsText: this.smsSetting[0].text,
                receiver1FirstAlarmSmsTimer: this.smsSetting[0].firstSmsDelay,
                receiver1NextAlarmSmsTimer: this.smsSetting[0].secondSmsDelay,
                receiver1SmsT_H: this.smsSetting[0].tempHum,
                receiver1SmsBeat: this.smsSetting[0].disconnect,
                receiver1SmsPower: this.smsSetting[0].power,

                receiver2SimCartNumber: this.smsSetting[1].phoneNumber,
                receiver2Beat: this.smsSetting[1].active,

                receiver2SmsText: this.smsSetting[1].text,
                receiver2FirstAlarmSmsTimer: this.smsSetting[1].firstSmsDelay,
                receiver2NextAlarmSmsTimer: this.smsSetting[1].secondSmsDelay,
                receiver2SmsT_H: this.smsSetting[1].tempHum,
                receiver2SmsBeat: this.smsSetting[1].disconnect,
                receiver2SmsPower: this.smsSetting[1].power,

                receiver3SimCartNumber: this.smsSetting[2].phoneNumber,
                receiver3Beat: this.smsSetting[2].active,

                receiver3SmsText: this.smsSetting[2].text,
                receiver3FirstAlarmSmsTimer: this.smsSetting[2].firstSmsDelay,
                receiver3NextAlarmSmsTimer: this.smsSetting[2].secondSmsDelay,
                receiver3SmsT_H: this.smsSetting[2].tempHum,
                receiver3SmsBeat: this.smsSetting[2].disconnect,
                receiver3SmsPower: this.smsSetting[2].power,

                receiver4SimCartNumber: this.smsSetting[3].phoneNumber,
                receiver4Beat: this.smsSetting[3].active,

                receiver4SmsText: this.smsSetting[3].text,
                receiver4FirstAlarmSmsTimer: this.smsSetting[3].firstSmsDelay,
                receiver4NextAlarmSmsTimer: this.smsSetting[3].secondSmsDelay,
                receiver4SmsT_H: this.smsSetting[3].tempHum,
                receiver4SmsBeat: this.smsSetting[3].disconnect,
                receiver4SmsPower: this.smsSetting[3].power,

                receiver5SimCartNumber: this.smsSetting[4].phoneNumber,
                receiver5Beat: this.smsSetting[4].active,

                receiver5SmsText: this.smsSetting[4].text,
                receiver5FirstAlarmSmsTimer: this.smsSetting[4].firstSmsDelay,
                receiver5NextAlarmSmsTimer: this.smsSetting[4].secondSmsDelay,
                receiver5SmsT_H: this.smsSetting[4].tempHum,
                receiver5SmsBeat: this.smsSetting[4].disconnect,
                receiver5SmsPower: this.smsSetting[4].power,

                receiver6SimCartNumber: this.smsSetting[5].phoneNumber,
                receiver6Beat: this.smsSetting[5].active,

                receiver6SmsText: this.smsSetting[5].text,
                receiver6FirstAlarmSmsTimer: this.smsSetting[5].firstSmsDelay,
                receiver6NextAlarmSmsTimer: this.smsSetting[5].secondSmsDelay,
                receiver6SmsT_H: this.smsSetting[5].tempHum,
                receiver6SmsBeat: this.smsSetting[5].disconnect,
                receiver6SmsPower: this.smsSetting[5].power,
              }
            )
            .then((response) => {
              this.spinnerSms = false;

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSms = false;

              console.log(error);
            });
        }
      } else if (data == "sensorTempHum") {
        var forms = document.querySelectorAll(
          ".needs-validationsensorTempHumFE22WE"
        );
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerSensorTempHum = true;

          axios
            .post(
              Values.serverIp +
                "FE22WEDeviceSetting/SetTemperatureSensorsSetting",
              {
                deviceId: this.deviceId,

                sensorIndex: this.sensorSetting.sensorIndex.value,
                receiver1TemperatureHigh: this.sensorTempHumSetting[0].tempUp,
                receiver1TemperatureLow: this.sensorTempHumSetting[0].tempDown,

                receiver2TemperatureHigh: this.sensorTempHumSetting[1].tempUp,
                receiver2TemperatureLow: this.sensorTempHumSetting[1].tempDown,

                receiver3TemperatureHigh: this.sensorTempHumSetting[2].tempUp,
                receiver3TemperatureLow: this.sensorTempHumSetting[2].tempDown,

                receiver4TemperatureHigh: this.sensorTempHumSetting[3].tempUp,
                receiver4TemperatureLow: this.sensorTempHumSetting[3].tempDown,

                receiver5TemperatureHigh: this.sensorTempHumSetting[4].tempUp,
                receiver5TemperatureLow: this.sensorTempHumSetting[4].tempDown,

                receiver6TemperatureHigh: this.sensorTempHumSetting[5].tempUp,
                receiver6TemperatureLow: this.sensorTempHumSetting[5].tempDown,

                receiver1HumidityHigh: this.sensorTempHumSetting[0].humUp,
                receiver1HumidityLow: this.sensorTempHumSetting[0].humDwon,

                receiver2HumidityHigh: this.sensorTempHumSetting[1].humUp,
                receiver2HumidityLow: this.sensorTempHumSetting[1].humDwon,

                receiver3HumidityHigh: this.sensorTempHumSetting[2].humUp,
                receiver3HumidityLow: this.sensorTempHumSetting[2].humDwon,

                receiver4HumidityHigh: this.sensorTempHumSetting[3].humUp,
                receiver4HumidityLow: this.sensorTempHumSetting[3].humDwon,

                receiver5HumidityHigh: this.sensorTempHumSetting[4].humUp,
                receiver5HumidityLow: this.sensorTempHumSetting[4].humDwon,

                receiver6HumidityHigh: this.sensorTempHumSetting[5].humUp,
                receiver6HumidityLow: this.sensorTempHumSetting[5].humDwon,
              }
            )
            .then((response) => {
              this.spinnerSensorTempHum = false;

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSensorTempHum = false;

              console.log(error);
            });
        }
      } else if (data == "sensorTempHum_hum") {
        var forms = document.querySelectorAll(
          ".needs-validationsensorTempHumFE22WE"
        );
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerSensorTempHum_hum = true;

          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/SetHumiditySensorsSetting",
              {
                deviceId: this.deviceId,

                sensorIndex: this.sensorSetting.sensorIndex.value,
                receiver1TemperatureHigh: this.sensorTempHumSetting[0].tempUp,
                receiver1TemperatureLow: this.sensorTempHumSetting[0].tempDown,

                receiver2TemperatureHigh: this.sensorTempHumSetting[1].tempUp,
                receiver2TemperatureLow: this.sensorTempHumSetting[1].tempDown,

                receiver3TemperatureHigh: this.sensorTempHumSetting[2].tempUp,
                receiver3TemperatureLow: this.sensorTempHumSetting[2].tempDown,

                receiver4TemperatureHigh: this.sensorTempHumSetting[3].tempUp,
                receiver4TemperatureLow: this.sensorTempHumSetting[3].tempDown,

                receiver5TemperatureHigh: this.sensorTempHumSetting[4].tempUp,
                receiver5TemperatureLow: this.sensorTempHumSetting[4].tempDown,

                receiver6TemperatureHigh: this.sensorTempHumSetting[5].tempUp,
                receiver6TemperatureLow: this.sensorTempHumSetting[5].tempDown,

                receiver1HumidityHigh: this.sensorTempHumSetting[0].humUp,
                receiver1HumidityLow: this.sensorTempHumSetting[0].humDwon,

                receiver2HumidityHigh: this.sensorTempHumSetting[1].humUp,
                receiver2HumidityLow: this.sensorTempHumSetting[1].humDwon,

                receiver3HumidityHigh: this.sensorTempHumSetting[2].humUp,
                receiver3HumidityLow: this.sensorTempHumSetting[2].humDwon,

                receiver4HumidityHigh: this.sensorTempHumSetting[3].humUp,
                receiver4HumidityLow: this.sensorTempHumSetting[3].humDwon,

                receiver5HumidityHigh: this.sensorTempHumSetting[4].humUp,
                receiver5HumidityLow: this.sensorTempHumSetting[4].humDwon,

                receiver6HumidityHigh: this.sensorTempHumSetting[5].humUp,
                receiver6HumidityLow: this.sensorTempHumSetting[5].humDwon,
              }
            )
            .then((response) => {
              this.spinnerSensorTempHum_hum = false;

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSensorTempHum_hum = false;

              console.log(error);
            });
        }
      } else if (data == "sensor") {
        var forms = document.querySelectorAll(".needs-validationSensorFE22WE");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }

        if (this.sensorSetting.sensorIndex.length == 0) {
          $(".needs-validationSensorFE22WE > .multiselect__tags").css(
            "border-color",
            "red"
          );
          formValid = false;
        }
        if (this.sensorSetting.type.length == 0) {
          $(".needs-validationSensorFE22WE > .multiselect__tags").css(
            "border-color",
            "red"
          );
          formValid = false;
        }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          let settingValuesSensor = [];

          for (var i = 0; i < this.sensorSetting.alarmRelay.length; i++) {
            settingValuesSensor.push({
              sensorType: this.sensorSetting.alarmRelay[i].type,
              validHighLimit:
                this.sensorSetting.alarmRelay[i].relayUp == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].relayUp,
              validLowLimit:
                this.sensorSetting.alarmRelay[i].relayDown == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].relayDown,
              alarmHighLimit:
                this.sensorSetting.alarmRelay[i].alarmDown == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].alarmDown,
              alarmLowLimit:
                this.sensorSetting.alarmRelay[i].alarmDown == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].alarmDown,
              calibration:
                this.sensorSetting.alarmRelay[i].collibrartion == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].collibrartion,
            });
          }

          this.spinnerSensor = true;

          axios
            .post(Values.serverIp + "FE22WEDeviceSetting/SetSensorsSetting", {
              deviceId: this.deviceId,
              // sensor
              sensorIndex: this.sensorSetting.sensorIndex.value,
              sensorTypeRegister: this.sensorSetting.type.value,
              sensorEnable: this.sensorSetting.active,
              sensorValuesList: settingValuesSensor,
            })
            .then((response) => {
              this.spinnerSensor = false;

              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSensor = false;

              console.log(error);
            });
        }
      }
    },

    //******************************************************************recieve Device Setting  */
    recieveDeviceSetting(data) {
      if (data == "ethernet") {
        this.spinnerEthernet = true;
        var forms = document.querySelectorAll(
          ".needs-validationEthernetFE22WE"
        );
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        // if (this.info.status.value == "") {
        //   $(".needs-validation > .multiselect__tags").css(
        //     "border-color",
        //     "red"
        //   );
        //   formValid = false;
        // }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(Values.serverIp + "FE22WEDeviceSetting/GetEthernetSetting", {
              deviceId: this.deviceId,

              //ethernet
              ehtrIpAddress: this.ethernet.ipAddress,
              ehtrMask: this.ethernet.subnetMask,
              ehtrGateway: this.ethernet.gateway,
              ehtrDns: this.ethernet.dns,
            })
            .then((response) => {
              this.spinnerEthernet = false;
              if (response.status == 200) {
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting("ethernet", this.deviceId, 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerEthernet = false;
              console.log(error);
            });
        }
      } else if (data == "voiceAlarm") {
        this.spinnerVoiceAlarm = true;
        var forms = document.querySelectorAll(".needs-validationAlarmFE22WE");
        let formValid = true;

        // if (this.info.status.value == "") {
        //   $(".needs-validation > .multiselect__tags").css(
        //     "border-color",
        //     "red"
        //   );
        //   formValid = false;
        // }

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/GetAlarmTimerSetting",
              {
                deviceId: this.deviceId,
                //voice alarm
                alarmDelay: 0,
                alarmDuration: 0,
                temperatureSoundAlarm: this.voiceAlarmInfo.voiceTemp,
                temperatureSmsAlarm: this.voiceAlarmInfo.smsTemp,
                humiditySoundAlarm: this.voiceAlarmInfo.voiceHum,
                humiditySmsAlarm: this.voiceAlarmInfo.smsHum,
              }
            )
            .then((response) => {
              this.spinnerVoiceAlarm = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting("voiceAlarm", this.deviceId, 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
              // modal successfuly
            })
            .catch((error) => {
              this.spinnerVoiceAlarm = false;
              console.log(error);
            });
        }
      } else if (data == "log") {
        this.spinnerLog = true;
        var forms = document.querySelectorAll(".needs-validationLogFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/GetStartupDelaySetting",
              {
                deviceId: this.deviceId,
                //voice alarm
                RefrigeratorStartupDelayInSeconds: 0,
              }
            )
            .then((response) => {
              this.spinnerLog = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting("log", this.deviceId, 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerLog = false;
              console.log(error);
            });
        }
      } else if (data == "server") {
        this.spinnerServer = true;
        var forms = document.querySelectorAll(".needs-validationServerFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/GetWebServiceSetting",
              {
                deviceId: this.deviceId,

                //server Ip
                webServiceEthernetAddressIp: this.serverInfo.ipAddressEthernet,
                webServiceUdpPort: 0,
                webBeatPeriodInSeconds: 0,
                wifiDebug: this.serverInfo.debugWifi,
                GprsDebaug: this.serverInfo.debugGprs,
                systemDebug: this.serverInfo.debugSystem,
                gprsBeat: this.serverInfo.gprs,
                wifiBeat: this.serverInfo.wifi,
                wifiAT: this.serverInfo.atWifi,
                gprsAT: this.serverInfo.atGprs,
                ethernetBeat: this.serverInfo.ethernet,
                webServiceGprsAddressIp: this.serverInfo.ipAddressGPRS,
                webServiceWifiAddressIp: this.serverInfo.ipAddressWifi,

                // webServiceUdpPort: this.serverInfo.port,
                // webBeatPeriodInSeconds: this.serverInfo.timeDistance,
                // GsmDebug: this.serverInfo.debugGsm,
              }
            )
            .then((response) => {
              this.spinnerServer = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting("server", this.deviceId, 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerServer = false;
              console.log(error);
            });
        }
      } else if (data == "puls") {
        this.spinnerPuls = true;
        var forms = document.querySelectorAll(".needs-validationPulsFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(Values.serverIp + "FE22WEDeviceSetting/GetBeatSetting", {
              deviceId: this.deviceId,

              //puls
              firstBeatTime: this.pulsInfo.first,
              secondBeatTime: this.pulsInfo.second,
            })
            .then((response) => {
              this.spinnerPuls = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting("puls", this.deviceId, 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerPuls = false;
              console.log(error);
            });
        }
      } else if (data == "dateTime") {
        this.spinnerPuls = true;

        axios
          .post(Values.serverIp + "FE22WEDeviceSetting/GetDateTimeSetting", {
            deviceId: this.deviceId,
          })
          .then((response) => {
            this.spinnerPuls = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.$emit("update", 1);
                this.refreshDeviceSetting("dateTime", this.deviceId, 1);
              } else if (response.data == 2) {
                this.$emit("update", 2);
              } else if (response.data == 3) {
                this.$emit("update", 3);
              } else if (response.data == 4) {
                this.$emit("update", 4);
              }
              // modal successfuly
            } else {
              this.$emit("update", 2);
            }
          })
          .catch((error) => {
            this.spinnerPuls = false;
            console.log(error);
          });
      } else if (data == "simcard") {
        this.spinnerSimcard = true;
        var forms = document.querySelectorAll(".needs-validationSimFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(Values.serverIp + "FE22WEDeviceSetting/GetSimCardSetting", {
              deviceId: this.deviceId,

              // //simcard
              simCardTypeOperator: 0,
            })
            .then((response) => {
              this.spinnerSimcard = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting("simcard", this.deviceId, 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSimcard = false;
              console.log(error);
            });
        }
      } else if (data == "serial") {
        this.spinnerSerialNumber = true;
        var forms = document.querySelectorAll(".needs-validationSimFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(Values.serverIp + "FE22WEDeviceSetting/GetSystemIdSetting", {
              deviceId: this.deviceId,
              systemId: this.serial.serialNumber,
            })
            .then((response) => {
              this.spinnerSerialNumber = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting("serial", this.deviceId, 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSerialNumber = false;
              console.log(error);
            });
        }
      } else if (data == "sms") {
        this.spinnerSms = true;
        var forms = document.querySelectorAll(".needs-validationSmsFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          console.log(this.smsSetting);
          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/GetSmsReceiversSetting",
              {
                deviceId: this.deviceId,

                // //simcard
                receiver1SimCartNumber: this.smsSetting[0].phoneNumber,
                receiver1Beat: this.smsSetting[0].active,

                receiver1SmsText: this.smsSetting[0].text,
                receiver1FirstAlarmSmsTimer: 0,
                receiver1NextAlarmSmsTimer: 0,
                receiver1SmsT_H: this.smsSetting[0].tempHum,
                receiver1SmsBeat: this.smsSetting[0].disconnect,
                receiver1SmsPower: this.smsSetting[0].power,

                receiver2SimCartNumber: this.smsSetting[1].phoneNumber,
                receiver2Beat: this.smsSetting[1].active,

                receiver2SmsText: this.smsSetting[1].text,
                receiver2FirstAlarmSmsTimer: 0,
                receiver2NextAlarmSmsTimer: 0,
                receiver2SmsT_H: this.smsSetting[1].tempHum,
                receiver2SmsBeat: this.smsSetting[1].disconnect,
                receiver2SmsPower: this.smsSetting[1].power,

                receiver3SimCartNumber: this.smsSetting[2].phoneNumber,
                receiver3Beat: this.smsSetting[2].active,

                receiver3SmsText: this.smsSetting[2].text,
                receiver3FirstAlarmSmsTimer: 0,
                receiver3NextAlarmSmsTimer: 0,
                receiver3SmsT_H: this.smsSetting[2].tempHum,
                receiver3SmsBeat: this.smsSetting[2].disconnect,
                receiver3SmsPower: this.smsSetting[2].power,

                receiver4SimCartNumber: this.smsSetting[3].phoneNumber,
                receiver4Beat: this.smsSetting[3].active,

                receiver4SmsText: this.smsSetting[3].text,
                receiver4FirstAlarmSmsTimer: 0,
                receiver4NextAlarmSmsTimer: 0,
                receiver4SmsT_H: this.smsSetting[3].tempHum,
                receiver4SmsBeat: this.smsSetting[3].disconnect,
                receiver4SmsPower: this.smsSetting[3].power,

                receiver5SimCartNumber: this.smsSetting[4].phoneNumber,
                receiver5Beat: this.smsSetting[4].active,

                receiver5SmsText: this.smsSetting[4].text,
                receiver5FirstAlarmSmsTimer: 0,
                receiver5NextAlarmSmsTimer: 0,
                receiver5SmsT_H: this.smsSetting[4].tempHum,
                receiver5SmsBeat: this.smsSetting[4].disconnect,
                receiver5SmsPower: this.smsSetting[4].power,

                receiver6SimCartNumber: this.smsSetting[5].phoneNumber,
                receiver6Beat: this.smsSetting[5].active,

                receiver6SmsText: this.smsSetting[5].text,
                receiver6FirstAlarmSmsTimer: 0,
                receiver6NextAlarmSmsTimer: 0,
                receiver6SmsT_H: this.smsSetting[5].tempHum,
                receiver6SmsBeat: this.smsSetting[5].disconnect,
                receiver6SmsPower: this.smsSetting[5].power,
              }
            )
            .then((response) => {
              this.spinnerSms = false;

              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting("sms", this.deviceId, 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSms = false;

              console.log(error);
            });
        }
      } else if (data == "smsFlag") {
        this.spinnerSms = true;
        var forms = document.querySelectorAll(".needs-validationSmsFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          console.log(this.smsSetting);
          axios
            .post(
              Values.serverIp +
                "FE22WEDeviceSetting/GetSmsReceiversMessageTextFlagSetting",
              {
                deviceId: this.deviceId,

                // //simcard
                receiver1SimCartNumber: this.smsSetting[0].phoneNumber,
                receiver1Beat: this.smsSetting[0].active,

                receiver1SmsText: this.smsSetting[0].text,
                receiver1FirstAlarmSmsTimer: 0,
                receiver1NextAlarmSmsTimer: 0,
                receiver1SmsT_H: this.smsSetting[0].tempHum,
                receiver1SmsBeat: this.smsSetting[0].disconnect,
                receiver1SmsPower: this.smsSetting[0].power,

                receiver2SimCartNumber: this.smsSetting[1].phoneNumber,
                receiver2Beat: this.smsSetting[1].active,

                receiver2SmsText: this.smsSetting[1].text,
                receiver2FirstAlarmSmsTimer: 0,
                receiver2NextAlarmSmsTimer: 0,
                receiver2SmsT_H: this.smsSetting[1].tempHum,
                receiver2SmsBeat: this.smsSetting[1].disconnect,
                receiver2SmsPower: this.smsSetting[1].power,

                receiver3SimCartNumber: this.smsSetting[2].phoneNumber,
                receiver3Beat: this.smsSetting[2].active,

                receiver3SmsText: this.smsSetting[2].text,
                receiver3FirstAlarmSmsTimer: 0,
                receiver3NextAlarmSmsTimer: 0,
                receiver3SmsT_H: this.smsSetting[2].tempHum,
                receiver3SmsBeat: this.smsSetting[2].disconnect,
                receiver3SmsPower: this.smsSetting[2].power,

                receiver4SimCartNumber: this.smsSetting[3].phoneNumber,
                receiver4Beat: this.smsSetting[3].active,

                receiver4SmsText: this.smsSetting[3].text,
                receiver4FirstAlarmSmsTimer: 0,
                receiver4NextAlarmSmsTimer: 0,
                receiver4SmsT_H: this.smsSetting[3].tempHum,
                receiver4SmsBeat: this.smsSetting[3].disconnect,
                receiver4SmsPower: this.smsSetting[3].power,

                receiver5SimCartNumber: this.smsSetting[4].phoneNumber,
                receiver5Beat: this.smsSetting[4].active,

                receiver5SmsText: this.smsSetting[4].text,
                receiver5FirstAlarmSmsTimer: 0,
                receiver5NextAlarmSmsTimer: 0,
                receiver5SmsT_H: this.smsSetting[4].tempHum,
                receiver5SmsBeat: this.smsSetting[4].disconnect,
                receiver5SmsPower: this.smsSetting[4].power,

                receiver6SimCartNumber: this.smsSetting[5].phoneNumber,
                receiver6Beat: this.smsSetting[5].active,

                receiver6SmsText: this.smsSetting[5].text,
                receiver6FirstAlarmSmsTimer: 0,
                receiver6NextAlarmSmsTimer: 0,
                receiver6SmsT_H: this.smsSetting[5].tempHum,
                receiver6SmsBeat: this.smsSetting[5].disconnect,
                receiver6SmsPower: this.smsSetting[5].power,
              }
            )
            .then((response) => {
              this.spinnerSms = false;

              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting("smsFlag", this.deviceId, 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSms = false;

              console.log(error);
            });
        }
      } else if (data == "smsDelay") {
        this.spinnerSms = true;
        var forms = document.querySelectorAll(".needs-validationSmsFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          console.log(this.smsSetting);
          axios
            .post(
              Values.serverIp +
                "FE22WEDeviceSetting/GetSmsReceiversSensorsAlarmTimerSetting",
              {
                deviceId: this.deviceId,

                // //simcard
                receiver1SimCartNumber: this.smsSetting[0].phoneNumber,
                receiver1Beat: this.smsSetting[0].active,

                receiver1SmsText: this.smsSetting[0].text,
                receiver1FirstAlarmSmsTimer: 0,
                receiver1NextAlarmSmsTimer: 0,
                receiver1SmsT_H: this.smsSetting[0].tempHum,
                receiver1SmsBeat: this.smsSetting[0].disconnect,
                receiver1SmsPower: this.smsSetting[0].power,

                receiver2SimCartNumber: this.smsSetting[1].phoneNumber,
                receiver2Beat: this.smsSetting[1].active,

                receiver2SmsText: this.smsSetting[1].text,
                receiver2FirstAlarmSmsTimer: 0,
                receiver2NextAlarmSmsTimer: 0,
                receiver2SmsT_H: this.smsSetting[1].tempHum,
                receiver2SmsBeat: this.smsSetting[1].disconnect,
                receiver2SmsPower: this.smsSetting[1].power,

                receiver3SimCartNumber: this.smsSetting[2].phoneNumber,
                receiver3Beat: this.smsSetting[2].active,

                receiver3SmsText: this.smsSetting[2].text,
                receiver3FirstAlarmSmsTimer: 0,
                receiver3NextAlarmSmsTimer: 0,
                receiver3SmsT_H: this.smsSetting[2].tempHum,
                receiver3SmsBeat: this.smsSetting[2].disconnect,
                receiver3SmsPower: this.smsSetting[2].power,

                receiver4SimCartNumber: this.smsSetting[3].phoneNumber,
                receiver4Beat: this.smsSetting[3].active,

                receiver4SmsText: this.smsSetting[3].text,
                receiver4FirstAlarmSmsTimer: 0,
                receiver4NextAlarmSmsTimer: 0,
                receiver4SmsT_H: this.smsSetting[3].tempHum,
                receiver4SmsBeat: this.smsSetting[3].disconnect,
                receiver4SmsPower: this.smsSetting[3].power,

                receiver5SimCartNumber: this.smsSetting[4].phoneNumber,
                receiver5Beat: this.smsSetting[4].active,

                receiver5SmsText: this.smsSetting[4].text,
                receiver5FirstAlarmSmsTimer: 0,
                receiver5NextAlarmSmsTimer: 0,
                receiver5SmsT_H: this.smsSetting[4].tempHum,
                receiver5SmsBeat: this.smsSetting[4].disconnect,
                receiver5SmsPower: this.smsSetting[4].power,

                receiver6SimCartNumber: this.smsSetting[5].phoneNumber,
                receiver6Beat: this.smsSetting[5].active,

                receiver6SmsText: this.smsSetting[5].text,
                receiver6FirstAlarmSmsTimer: 0,
                receiver6NextAlarmSmsTimer: 0,
                receiver6SmsT_H: this.smsSetting[5].tempHum,
                receiver6SmsBeat: this.smsSetting[5].disconnect,
                receiver6SmsPower: this.smsSetting[5].power,
              }
            )
            .then((response) => {
              this.spinnerSms = false;

              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting("smsDelay", this.deviceId, 1);
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSms = false;

              console.log(error);
            });
        }
      } else if (data == "sensorTempHum") {
        this.spinnerSensorTempHum = true;

        var forms = document.querySelectorAll(
          ".needs-validationsensorTempHumFE22WE"
        );
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp +
                "FE22WEDeviceSetting/GetTemperatureSensorsSetting",
              {
                deviceId: this.deviceId,

                sensorIndex: this.sensorSetting.sensorIndex.value,
                receiver1TemperatureHigh: this.sensorTempHumSetting[0].tempUp,
                receiver1TemperatureLow: this.sensorTempHumSetting[0].tempDown,

                receiver2TemperatureHigh: this.sensorTempHumSetting[1].tempUp,
                receiver2TemperatureLow: this.sensorTempHumSetting[1].tempDown,

                receiver3TemperatureHigh: this.sensorTempHumSetting[2].tempUp,
                receiver3TemperatureLow: this.sensorTempHumSetting[2].tempDown,

                receiver4TemperatureHigh: this.sensorTempHumSetting[3].tempUp,
                receiver4TemperatureLow: this.sensorTempHumSetting[3].tempDown,

                receiver5TemperatureHigh: this.sensorTempHumSetting[4].tempUp,
                receiver5TemperatureLow: this.sensorTempHumSetting[4].tempDown,

                receiver6TemperatureHigh: this.sensorTempHumSetting[5].tempUp,
                receiver6TemperatureLow: this.sensorTempHumSetting[5].tempDown,

                receiver1HumidityHigh: this.sensorTempHumSetting[0].humUp,
                receiver1HumidityLow: this.sensorTempHumSetting[0].humDwon,

                receiver2HumidityHigh: this.sensorTempHumSetting[1].humUp,
                receiver2HumidityLow: this.sensorTempHumSetting[1].humDwon,

                receiver3HumidityHigh: this.sensorTempHumSetting[2].humUp,
                receiver3HumidityLow: this.sensorTempHumSetting[2].humDwon,

                receiver4HumidityHigh: this.sensorTempHumSetting[3].humUp,
                receiver4HumidityLow: this.sensorTempHumSetting[3].humDwon,

                receiver5HumidityHigh: this.sensorTempHumSetting[4].humUp,
                receiver5HumidityLow: this.sensorTempHumSetting[4].humDwon,

                receiver6HumidityHigh: this.sensorTempHumSetting[5].humUp,
                receiver6HumidityLow: this.sensorTempHumSetting[5].humDwon,
              }
            )
            .then((response) => {
              this.spinnerSensorTempHum = false;

              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting(
                    "sensorTempHum",
                    this.deviceId,
                    this.sensorSetting.sensorIndex.value
                  );
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSensorTempHum = false;

              console.log(error);
            });
        }
      } else if (data == "sensorTempHum_hum") {
        this.spinnerSensorTempHum_hum = true;

        var forms = document.querySelectorAll(
          ".needs-validationsensorTempHumFE22WE"
        );
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/GetHumiditySensorsSetting",
              {
                deviceId: this.deviceId,

                sensorIndex: this.sensorSetting.sensorIndex.value,
                receiver1TemperatureHigh: this.sensorTempHumSetting[0].tempUp,
                receiver1TemperatureLow: this.sensorTempHumSetting[0].tempDown,

                receiver2TemperatureHigh: this.sensorTempHumSetting[1].tempUp,
                receiver2TemperatureLow: this.sensorTempHumSetting[1].tempDown,

                receiver3TemperatureHigh: this.sensorTempHumSetting[2].tempUp,
                receiver3TemperatureLow: this.sensorTempHumSetting[2].tempDown,

                receiver4TemperatureHigh: this.sensorTempHumSetting[3].tempUp,
                receiver4TemperatureLow: this.sensorTempHumSetting[3].tempDown,

                receiver5TemperatureHigh: this.sensorTempHumSetting[4].tempUp,
                receiver5TemperatureLow: this.sensorTempHumSetting[4].tempDown,

                receiver6TemperatureHigh: this.sensorTempHumSetting[5].tempUp,
                receiver6TemperatureLow: this.sensorTempHumSetting[5].tempDown,

                receiver1HumidityHigh: this.sensorTempHumSetting[0].humUp,
                receiver1HumidityLow: this.sensorTempHumSetting[0].humDwon,

                receiver2HumidityHigh: this.sensorTempHumSetting[1].humUp,
                receiver2HumidityLow: this.sensorTempHumSetting[1].humDwon,

                receiver3HumidityHigh: this.sensorTempHumSetting[2].humUp,
                receiver3HumidityLow: this.sensorTempHumSetting[2].humDwon,

                receiver4HumidityHigh: this.sensorTempHumSetting[3].humUp,
                receiver4HumidityLow: this.sensorTempHumSetting[3].humDwon,

                receiver5HumidityHigh: this.sensorTempHumSetting[4].humUp,
                receiver5HumidityLow: this.sensorTempHumSetting[4].humDwon,

                receiver6HumidityHigh: this.sensorTempHumSetting[5].humUp,
                receiver6HumidityLow: this.sensorTempHumSetting[5].humDwon,
              }
            )
            .then((response) => {
              this.spinnerSensorTempHum_hum = false;

              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting(
                    "sensorTempHum_hum",
                    this.deviceId,
                    this.sensorSetting.sensorIndex.value
                  );
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSensorTempHum_hum = false;

              console.log(error);
            });
        }
      } else if (data == "sensor") {
        this.spinnerSensor = true;
        var forms = document.querySelectorAll(".needs-validationSensorFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          let settingValuesSensor = [];

          for (var i = 0; i < this.sensorSetting.alarmRelay.length; i++) {
            settingValuesSensor.push({
              sensorType: this.sensorSetting.alarmRelay[i].type,
              validHighLimit:
                this.sensorSetting.alarmRelay[i].relayUp == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].relayUp,
              validLowLimit:
                this.sensorSetting.alarmRelay[i].relayDown == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].relayDown,
              alarmHighLimit:
                this.sensorSetting.alarmRelay[i].alarmDown == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].alarmDown,
              alarmLowLimit:
                this.sensorSetting.alarmRelay[i].alarmDown == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].alarmDown,
              calibration:
                this.sensorSetting.alarmRelay[i].collibrartion == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].collibrartion,
            });
          }

          axios
            .post(Values.serverIp + "FE22WEDeviceSetting/GetSensorsSetting", {
              deviceId: this.deviceId,
              // sensor
              sensorIndex: this.sensorSetting.sensorIndex.value,
              sensorTypeRegister: this.sensorSetting.type.value,
              sensorEnable: this.sensorSetting.active,
              sensorValuesList: settingValuesSensor,
            })
            .then((response) => {
              this.spinnerSensor = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.$emit("update", 1);
                  this.refreshDeviceSetting(
                    "sensor",
                    this.deviceId,
                    this.sensorSetting.sensorIndex.value
                  );
                } else if (response.data == 2) {
                  this.$emit("update", 2);
                } else if (response.data == 3) {
                  this.$emit("update", 3);
                } else if (response.data == 4) {
                  this.$emit("update", 4);
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              this.spinnerSensor = false;
              console.log(error);
            });
        }
      }
    },

    //   *********************************************************************set Device Setting
    refreshDeviceSetting(data, deviceId, sensorId) {
      if (data == "ethernet") {
        var forms = document.querySelectorAll(
          ".needs-validationEthernetFE22WE"
        );
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/GetEthernetSettingValue",
              {
                deviceId: deviceId,

                //ethernet
                ehtrIpAddress: this.ethernet.ipAddress,
                ehtrMask: this.ethernet.subnetMask,
                ehtrGateway: this.ethernet.gateway,
                ehtrDns: this.ethernet.dns,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                this.ethernet.ipAddress = response.data.ehtrIpAddress;
                this.ethernet.subnetMask = response.data.ehtrMask;
                this.ethernet.gateway = response.data.ehtrGateway;
                this.ethernet.dns = response.data.ehtrDns;
                this.ethernet.updateTime =
                  response.data.ethernetInformationLastUpdateDateTimeJalali;
              } else {
                // modal unsuccessful edit change
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (data == "voiceAlarm") {
        var forms = document.querySelectorAll(".needs-validationAlarmFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/GetAlarmTimerSettingValue",
              {
                deviceId: deviceId,
                //voice alarm
                alarmDelay: 0,
                alarmDuration: 0,
                temperatureSoundAlarm: this.voiceAlarmInfo.voiceTemp,
                temperatureSmsAlarm: this.voiceAlarmInfo.smsTemp,
                humiditySoundAlarm: this.voiceAlarmInfo.voiceHum,
                humiditySmsAlarm: this.voiceAlarmInfo.smsHum,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                this.voiceAlarmInfo.delay = response.data.alarmDelay;
                this.voiceAlarmInfo.length = response.data.alarmDuration;
                this.voiceAlarmInfo.voiceTemp =
                  response.data.temperatureSoundAlarm;
                this.voiceAlarmInfo.smsTemp = response.data.temperatureSmsAlarm;
                this.voiceAlarmInfo.voiceHum = response.data.humiditySoundAlarm;
                this.voiceAlarmInfo.smsHum = response.data.humiditySmsAlarm;
                this.voiceAlarmInfo.updateTime =
                  response.data.timerAlarmInformationLastUpdateDateTimeJalali;

                // modal successfuly
              } else {
                this.$emit("update", 2);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (data == "log") {
        var forms = document.querySelectorAll(".needs-validationLogFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp +
                "FE22WEDeviceSetting/GetStartupDelaySettingValue",
              {
                deviceId: deviceId,
                //voice alarm
                RefrigeratorStartupDelayInSeconds: 0,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                this.logInfo.distance =
                  response.data.refrigeratorStartupDelayInSeconds;

                this.logInfo.updateTime =
                  response.data.refrigeratorStartupDelayInSecondsLastUpdateDateTimeJalali;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (data == "server") {
        var forms = document.querySelectorAll(".needs-validationServerFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/GetWebServiceSettingValue",
              {
                deviceId: deviceId,

                //server Ip
                webServiceEthernetAddressIp: this.serverInfo.ipAddressEthernet,
                webServiceUdpPort: 0,
                webBeatPeriodInSeconds: 0,
                wifiDebug: this.serverInfo.debugWifi,
                GprsDebaug: this.serverInfo.debugGprs,
                systemDebug: this.serverInfo.debugSystem,
                gprsBeat: this.serverInfo.gprs,
                wifiBeat: this.serverInfo.wifi,
                wifiAT: this.serverInfo.atWifi,
                gprsAT: this.serverInfo.atGprs,
                ethernetBeat: this.serverInfo.ethernet,
                webServiceGprsAddressIp: this.serverInfo.ipAddressGPRS,
                webServiceWifiAddressIp: this.serverInfo.ipAddressWifi,

                // webServiceUdpPort: this.serverInfo.port,
                // webBeatPeriodInSeconds: this.serverInfo.timeDistance,
                // GsmDebug: this.serverInfo.debugGsm,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                this.serverInfo.ipAddressEthernet =
                  response.data.webServiceEthernetAddressIp;
                this.serverInfo.port = response.data.webServiceUdpPort;
                this.serverInfo.timeDistance =
                  response.data.webBeatPeriodInSeconds;
                this.serverInfo.debugWifi = response.data.wifiDebug;
                this.serverInfo.debugGprs = response.data.GprsDebaug;
                this.serverInfo.debugSystem = response.data.systemDebug;
                this.serverInfo.gprs = response.data.gprsBeat;
                this.serverInfo.wifi = response.data.wifiBeat;
                this.serverInfo.atWifi = response.data.wifiAT;
                this.serverInfo.atGprs = response.data.gprsAT;
                this.serverInfo.ethernet = response.data.ethernetBeat;
                this.serverInfo.ipAddressGPRS =
                  response.data.webServiceGprsAddressIp;
                this.serverInfo.ipAddressWifi =
                  response.data.webServiceWifiAddressIp;
                this.serverInfo.updateTime =
                  response.data.webServiceInformationLastUpdateDateTimeJalali;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (data == "puls") {
        var forms = document.querySelectorAll(".needs-validationPulsFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(Values.serverIp + "FE22WEDeviceSetting/GetBeatSettingValue", {
              deviceId: deviceId,

              //puls
              firstBeatTime: this.pulsInfo.first,
              secondBeatTime: this.pulsInfo.second,
            })
            .then((response) => {
              if (response.status == 200) {
                this.pulsInfo.first = response.data.firstBeatTime;
                this.pulsInfo.second = response.data.secondBeatTime;
                this.pulsInfo.updateTime =
                  response.data.beatInformationLastUpdateDateTimeJalali;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (data == "dateTime") {
        axios
          .post(
            Values.serverIp + "FE22WEDeviceSetting/GetDateTimeSettingValue",
            {
              deviceId: deviceId,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              console.log(response.data);
              this.dateTime.updateTime =
                response.data.dateTimeLastUpdateDateTimeJalali;
              this.dateTime.dateTime = response.data.dateTime;
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (data == "simcard") {
        var forms = document.querySelectorAll(".needs-validationSimFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/GetSimCardSettingValue",
              {
                deviceId: deviceId,

                // //simcard
                simCardTypeOperator: 0,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                // this.SimcardOprator.id=response.data.simCardTypeOperator;
                // this.SimcardType.id=response.data.simCardTypeCreditOrFixed;
                this.setSimcardOprator(response.data.simCardTypeOperator);
                this.simcardUpdateTime =
                  response.data.simCardInformationLastUpdateDateTimeJalali;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (data == "serial") {
        var forms = document.querySelectorAll(".needs-validationSimFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/GetSystemIdSettingValue",
              {
                deviceId: deviceId,
                systemId: this.serial.serialNumber,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                console.log(response.data);
                this.serial.serialTime =
                  response.data.systemIdLastUpdateDateTimeJalali;
                this.serial.serialNumber = response.data.systemId;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (data == "sms") {
        var forms = document.querySelectorAll(".needs-validationSmsFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp +
                "FE22WEDeviceSetting/GetSmsReceiversSettingValue",
              {
                deviceId: deviceId,

                // //simcard
                receiver1SimCartNumber: this.smsSetting[0].phoneNumber,
                receiver1Beat: this.smsSetting[0].active,

                receiver1SmsText: this.smsSetting[0].text,
                receiver1FirstAlarmSmsTimer: 0,
                receiver1NextAlarmSmsTimer: 0,
                receiver1SmsT_H: this.smsSetting[0].tempHum,
                receiver1SmsBeat: this.smsSetting[0].disconnect,
                receiver1SmsPower: this.smsSetting[0].power,

                receiver2SimCartNumber: this.smsSetting[1].phoneNumber,
                receiver2Beat: this.smsSetting[1].active,

                receiver2SmsText: this.smsSetting[1].text,
                receiver2FirstAlarmSmsTimer: 0,
                receiver2NextAlarmSmsTimer: 0,
                receiver2SmsT_H: this.smsSetting[1].tempHum,
                receiver2SmsBeat: this.smsSetting[1].disconnect,
                receiver2SmsPower: this.smsSetting[1].power,

                receiver3SimCartNumber: this.smsSetting[2].phoneNumber,
                receiver3Beat: this.smsSetting[2].active,

                receiver3SmsText: this.smsSetting[2].text,
                receiver3FirstAlarmSmsTimer: 0,
                receiver3NextAlarmSmsTimer: 0,
                receiver3SmsT_H: this.smsSetting[2].tempHum,
                receiver3SmsBeat: this.smsSetting[2].disconnect,
                receiver3SmsPower: this.smsSetting[2].power,

                receiver4SimCartNumber: this.smsSetting[3].phoneNumber,
                receiver4Beat: this.smsSetting[3].active,

                receiver4SmsText: this.smsSetting[3].text,
                receiver4FirstAlarmSmsTimer: 0,
                receiver4NextAlarmSmsTimer: 0,
                receiver4SmsT_H: this.smsSetting[3].tempHum,
                receiver4SmsBeat: this.smsSetting[3].disconnect,
                receiver4SmsPower: this.smsSetting[3].power,

                receiver5SimCartNumber: this.smsSetting[4].phoneNumber,
                receiver5Beat: this.smsSetting[4].active,

                receiver5SmsText: this.smsSetting[4].text,
                receiver5FirstAlarmSmsTimer: 0,
                receiver5NextAlarmSmsTimer: 0,
                receiver5SmsT_H: this.smsSetting[4].tempHum,
                receiver5SmsBeat: this.smsSetting[4].disconnect,
                receiver5SmsPower: this.smsSetting[4].power,

                receiver6SimCartNumber: this.smsSetting[5].phoneNumber,
                receiver6Beat: this.smsSetting[5].active,

                receiver6SmsText: this.smsSetting[5].text,
                receiver6FirstAlarmSmsTimer: 0,
                receiver6NextAlarmSmsTimer: 0,
                receiver6SmsT_H: this.smsSetting[5].tempHum,
                receiver6SmsBeat: this.smsSetting[5].disconnect,
                receiver6SmsPower: this.smsSetting[5].power,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                console.log(response.data);
                this.smsSetting[0].phoneNumber =
                  response.data.receiver1SimCartNumber;
                this.smsSetting[0].active = response.data.receiver1Beat;

                // this.smsSetting[0].text = response.data.receiver1SmsText;
                // this.smsSetting[0].firstSmsDelay =
                //   response.data.receiver1FirstAlarmSmsTimer;
                // this.smsSetting[0].secondSmsDelay =
                //   response.data.receiver1NextAlarmSmsTimer;

                // this.smsSetting[0].tempHum = response.data.receiver1SmsT_H;
                // this.smsSetting[0].disconnect = response.data.receiver1SmsBeat;
                // this.smsSetting[0].power = response.data.receiver1SmsPower;

                this.smsSetting[1].phoneNumber =
                  response.data.receiver2SimCartNumber;
                this.smsSetting[1].active = response.data.receiver2Beat;

                // this.smsSetting[1].text = response.data.receiver2SmsText;
                // this.smsSetting[1].firstSmsDelay =
                //   response.data.receiver2FirstAlarmSmsTimer;
                // this.smsSetting[1].secondSmsDelay =
                //   response.data.receiver2NextAlarmSmsTimer;
                // this.smsSetting[1].tempHum = response.data.receiver2SmsT_H;
                // this.smsSetting[1].disconnect = response.data.receiver2SmsBeat;
                // this.smsSetting[1].power = response.data.receiver2SmsPower;

                this.smsSetting[2].phoneNumber =
                  response.data.receiver3SimCartNumber;
                this.smsSetting[2].active = response.data.receiver3Beat;

                // this.smsSetting[2].text = response.data.receiver3SmsText;
                // this.smsSetting[2].firstSmsDelay =
                //   response.data.receiver3FirstAlarmSmsTimer;
                // this.smsSetting[2].secondSmsDelay =
                //   response.data.receiver3NextAlarmSmsTimer;
                // this.smsSetting[2].tempHum = response.data.receiver3SmsT_H;
                // this.smsSetting[2].disconnect = response.data.receiver3SmsBeat;
                // this.smsSetting[2].power = response.data.receiver3SmsPower;

                this.smsSetting[3].phoneNumber =
                  response.data.receiver4SimCartNumber;
                this.smsSetting[3].active = response.data.receiver4Beat;

                // this.smsSetting[3].text = response.data.receiver4SmsText;
                // this.smsSetting[3].firstSmsDelay =
                //   response.data.receiver4FirstAlarmSmsTimer;
                // this.smsSetting[3].secondSmsDelay =
                //   response.data.receiver4NextAlarmSmsTimer;
                // this.smsSetting[3].tempHum = response.data.receiver4SmsT_H;
                // this.smsSetting[3].disconnect = response.data.receiver4SmsBeat;
                // this.smsSetting[3].power = response.data.receiver4SmsPower;

                this.smsSetting[4].phoneNumber =
                  response.data.receiver5SimCartNumber;
                this.smsSetting[4].active = response.data.receiver5Beat;

                // this.smsSetting[4].text = response.data.receiver5SmsText;
                // this.smsSetting[4].firstSmsDelay =
                //   response.data.receiver5FirstAlarmSmsTimer;
                // this.smsSetting[4].secondSmsDelay =
                //   response.data.receiver5NextAlarmSmsTimer;
                // this.smsSetting[4].tempHum = response.data.receiver5SmsT_H;
                // this.smsSetting[4].disconnect = response.data.receiver5SmsBeat;
                // this.smsSetting[4].power = response.data.receiver5SmsPower;

                this.smsSetting[5].phoneNumber =
                  response.data.receiver6SimCartNumber;
                this.smsSetting[5].active = response.data.receiver6Beat;

                // this.smsSetting[5].text = response.data.receiver6SmsText;
                // this.smsSetting[5].firstSmsDelay =
                //   response.data.receiver6FirstAlarmSmsTimer;
                // this.smsSetting[5].secondSmsDelay =
                //   response.data.receiver6NextAlarmSmsTimer;
                // this.smsSetting[5].tempHum = response.data.receiver6SmsT_H;
                // this.smsSetting[5].disconnect = response.data.receiver6SmsBeat;
                // this.smsSetting[5].power = response.data.receiver6SmsPower;
                this.smsUpdateTime =
                  response.data.receiversSimCartNumberInformationLastUpdateDateTimeJalali;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (data == "smsFlag") {
        var forms = document.querySelectorAll(".needs-validationSmsFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp +
                "FE22WEDeviceSetting/GetSmsReceiversMessageTextFlagSettingValue",
              {
                deviceId: deviceId,

                // //simcard
                receiver1SimCartNumber: this.smsSetting[0].phoneNumber,
                receiver1Beat: this.smsSetting[0].active,

                receiver1SmsText: this.smsSetting[0].text,
                receiver1FirstAlarmSmsTimer: 0,
                receiver1NextAlarmSmsTimer: 0,
                receiver1SmsT_H: this.smsSetting[0].tempHum,
                receiver1SmsBeat: this.smsSetting[0].disconnect,
                receiver1SmsPower: this.smsSetting[0].power,

                receiver2SimCartNumber: this.smsSetting[1].phoneNumber,
                receiver2Beat: this.smsSetting[1].active,

                receiver2SmsText: this.smsSetting[1].text,
                receiver2FirstAlarmSmsTimer: 0,
                receiver2NextAlarmSmsTimer: 0,
                receiver2SmsT_H: this.smsSetting[1].tempHum,
                receiver2SmsBeat: this.smsSetting[1].disconnect,
                receiver2SmsPower: this.smsSetting[1].power,

                receiver3SimCartNumber: this.smsSetting[2].phoneNumber,
                receiver3Beat: this.smsSetting[2].active,

                receiver3SmsText: this.smsSetting[2].text,
                receiver3FirstAlarmSmsTimer: 0,
                receiver3NextAlarmSmsTimer: 0,
                receiver3SmsT_H: this.smsSetting[2].tempHum,
                receiver3SmsBeat: this.smsSetting[2].disconnect,
                receiver3SmsPower: this.smsSetting[2].power,

                receiver4SimCartNumber: this.smsSetting[3].phoneNumber,
                receiver4Beat: this.smsSetting[3].active,

                receiver4SmsText: this.smsSetting[3].text,
                receiver4FirstAlarmSmsTimer: 0,
                receiver4NextAlarmSmsTimer: 0,
                receiver4SmsT_H: this.smsSetting[3].tempHum,
                receiver4SmsBeat: this.smsSetting[3].disconnect,
                receiver4SmsPower: this.smsSetting[3].power,

                receiver5SimCartNumber: this.smsSetting[4].phoneNumber,
                receiver5Beat: this.smsSetting[4].active,

                receiver5SmsText: this.smsSetting[4].text,
                receiver5FirstAlarmSmsTimer: 0,
                receiver5NextAlarmSmsTimer: 0,
                receiver5SmsT_H: this.smsSetting[4].tempHum,
                receiver5SmsBeat: this.smsSetting[4].disconnect,
                receiver5SmsPower: this.smsSetting[4].power,

                receiver6SimCartNumber: this.smsSetting[5].phoneNumber,
                receiver6Beat: this.smsSetting[5].active,

                receiver6SmsText: this.smsSetting[5].text,
                receiver6FirstAlarmSmsTimer: 0,
                receiver6NextAlarmSmsTimer: 0,
                receiver6SmsT_H: this.smsSetting[5].tempHum,
                receiver6SmsBeat: this.smsSetting[5].disconnect,
                receiver6SmsPower: this.smsSetting[5].power,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                // this.smsSetting[0].phoneNumber =
                //   response.data.receiver1SimCartNumber;
                // this.smsSetting[0].active = response.data.receiver1Beat;

                this.smsSetting[0].text = response.data.receiver1SmsText;
                // this.smsSetting[0].firstSmsDelay =
                //   response.data.receiver1FirstAlarmSmsTimer;
                // this.smsSetting[0].secondSmsDelay =
                //   response.data.receiver1NextAlarmSmsTimer;

                this.smsSetting[0].tempHum = response.data.receiver1SmsT_H;
                this.smsSetting[0].disconnect = response.data.receiver1SmsBeat;
                this.smsSetting[0].power = response.data.receiver1SmsPower;

                // this.smsSetting[1].phoneNumber =
                //   response.data.receiver2SimCartNumber;
                // this.smsSetting[1].active = response.data.receiver2Beat;

                this.smsSetting[1].text = response.data.receiver2SmsText;
                // this.smsSetting[1].firstSmsDelay =
                //   response.data.receiver2FirstAlarmSmsTimer;
                // this.smsSetting[1].secondSmsDelay =
                //   response.data.receiver2NextAlarmSmsTimer;
                this.smsSetting[1].tempHum = response.data.receiver2SmsT_H;
                this.smsSetting[1].disconnect = response.data.receiver2SmsBeat;
                this.smsSetting[1].power = response.data.receiver2SmsPower;

                // this.smsSetting[2].phoneNumber =
                //   response.data.receiver3SimCartNumber;
                // this.smsSetting[2].active = response.data.receiver3Beat;

                this.smsSetting[2].text = response.data.receiver3SmsText;
                // this.smsSetting[2].firstSmsDelay =
                //   response.data.receiver3FirstAlarmSmsTimer;
                // this.smsSetting[2].secondSmsDelay =
                //   response.data.receiver3NextAlarmSmsTimer;
                this.smsSetting[2].tempHum = response.data.receiver3SmsT_H;
                this.smsSetting[2].disconnect = response.data.receiver3SmsBeat;
                this.smsSetting[2].power = response.data.receiver3SmsPower;

                // this.smsSetting[3].phoneNumber =
                //   response.data.receiver4SimCartNumber;
                // this.smsSetting[3].active = response.data.receiver4Beat;

                this.smsSetting[3].text = response.data.receiver4SmsText;
                // this.smsSetting[3].firstSmsDelay =
                //   response.data.receiver4FirstAlarmSmsTimer;
                // this.smsSetting[3].secondSmsDelay =
                //   response.data.receiver4NextAlarmSmsTimer;
                this.smsSetting[3].tempHum = response.data.receiver4SmsT_H;
                this.smsSetting[3].disconnect = response.data.receiver4SmsBeat;
                this.smsSetting[3].power = response.data.receiver4SmsPower;

                // this.smsSetting[4].phoneNumber =
                //   response.data.receiver5SimCartNumber;
                // this.smsSetting[4].active = response.data.receiver5Beat;

                this.smsSetting[4].text = response.data.receiver5SmsText;
                // this.smsSetting[4].firstSmsDelay =
                //   response.data.receiver5FirstAlarmSmsTimer;
                // this.smsSetting[4].secondSmsDelay =
                //   response.data.receiver5NextAlarmSmsTimer;
                this.smsSetting[4].tempHum = response.data.receiver5SmsT_H;
                this.smsSetting[4].disconnect = response.data.receiver5SmsBeat;
                this.smsSetting[4].power = response.data.receiver5SmsPower;

                // this.smsSetting[5].phoneNumber =
                //   response.data.receiver6SimCartNumber;
                // this.smsSetting[5].active = response.data.receiver6Beat;

                this.smsSetting[5].text = response.data.receiver6SmsText;
                // this.smsSetting[5].firstSmsDelay =
                //   response.data.receiver6FirstAlarmSmsTimer;
                // this.smsSetting[5].secondSmsDelay =
                //   response.data.receiver6NextAlarmSmsTimer;
                this.smsSetting[5].tempHum = response.data.receiver6SmsT_H;
                this.smsSetting[5].disconnect = response.data.receiver6SmsBeat;
                this.smsSetting[5].power = response.data.receiver6SmsPower;
                this.smsUpdateTimeFlag =
                  response.data.receiversSmsTextInformationLastUpdateDateTimeJalali;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (data == "smsDelay") {
        var forms = document.querySelectorAll(".needs-validationSmsFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          axios
            .post(
              Values.serverIp +
                "FE22WEDeviceSetting/GetSmsReceiversSensorsAlarmTimerSettingValue",
              {
                deviceId: deviceId,

                // //simcard
                receiver1SimCartNumber: this.smsSetting[0].phoneNumber,
                receiver1Beat: this.smsSetting[0].active,

                receiver1SmsText: this.smsSetting[0].text,
                receiver1FirstAlarmSmsTimer: 0,
                receiver1NextAlarmSmsTimer: 0,
                receiver1SmsT_H: this.smsSetting[0].tempHum,
                receiver1SmsBeat: this.smsSetting[0].disconnect,
                receiver1SmsPower: this.smsSetting[0].power,

                receiver2SimCartNumber: this.smsSetting[1].phoneNumber,
                receiver2Beat: this.smsSetting[1].active,

                receiver2SmsText: this.smsSetting[1].text,
                receiver2FirstAlarmSmsTimer: 0,
                receiver2NextAlarmSmsTimer: 0,
                receiver2SmsT_H: this.smsSetting[1].tempHum,
                receiver2SmsBeat: this.smsSetting[1].disconnect,
                receiver2SmsPower: this.smsSetting[1].power,

                receiver3SimCartNumber: this.smsSetting[2].phoneNumber,
                receiver3Beat: this.smsSetting[2].active,

                receiver3SmsText: this.smsSetting[2].text,
                receiver3FirstAlarmSmsTimer: 0,
                receiver3NextAlarmSmsTimer: 0,
                receiver3SmsT_H: this.smsSetting[2].tempHum,
                receiver3SmsBeat: this.smsSetting[2].disconnect,
                receiver3SmsPower: this.smsSetting[2].power,

                receiver4SimCartNumber: this.smsSetting[3].phoneNumber,
                receiver4Beat: this.smsSetting[3].active,

                receiver4SmsText: this.smsSetting[3].text,
                receiver4FirstAlarmSmsTimer: 0,
                receiver4NextAlarmSmsTimer: 0,
                receiver4SmsT_H: this.smsSetting[3].tempHum,
                receiver4SmsBeat: this.smsSetting[3].disconnect,
                receiver4SmsPower: this.smsSetting[3].power,

                receiver5SimCartNumber: this.smsSetting[4].phoneNumber,
                receiver5Beat: this.smsSetting[4].active,

                receiver5SmsText: this.smsSetting[4].text,
                receiver5FirstAlarmSmsTimer: 0,
                receiver5NextAlarmSmsTimer: 0,
                receiver5SmsT_H: this.smsSetting[4].tempHum,
                receiver5SmsBeat: this.smsSetting[4].disconnect,
                receiver5SmsPower: this.smsSetting[4].power,

                receiver6SimCartNumber: this.smsSetting[5].phoneNumber,
                receiver6Beat: this.smsSetting[5].active,

                receiver6SmsText: this.smsSetting[5].text,
                receiver6FirstAlarmSmsTimer: 0,
                receiver6NextAlarmSmsTimer: 0,
                receiver6SmsT_H: this.smsSetting[5].tempHum,
                receiver6SmsBeat: this.smsSetting[5].disconnect,
                receiver6SmsPower: this.smsSetting[5].power,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                // this.smsSetting[0].phoneNumber =
                //   response.data.receiver1SimCartNumber;
                // this.smsSetting[0].active = response.data.receiver1Beat;

                // this.smsSetting[0].text = response.data.receiver1SmsText;
                this.smsSetting[0].firstSmsDelay =
                  response.data.receiver1FirstAlarmSmsTimer;
                this.smsSetting[0].secondSmsDelay =
                  response.data.receiver1NextAlarmSmsTimer;

                // this.smsSetting[0].tempHum = response.data.receiver1SmsT_H;
                // this.smsSetting[0].disconnect = response.data.receiver1SmsBeat;
                // this.smsSetting[0].power = response.data.receiver1SmsPower;

                // this.smsSetting[1].phoneNumber =
                //   response.data.receiver2SimCartNumber;
                // this.smsSetting[1].active = response.data.receiver2Beat;

                // this.smsSetting[1].text = response.data.receiver2SmsText;
                this.smsSetting[1].firstSmsDelay =
                  response.data.receiver2FirstAlarmSmsTimer;
                this.smsSetting[1].secondSmsDelay =
                  response.data.receiver2NextAlarmSmsTimer;
                // this.smsSetting[1].tempHum = response.data.receiver2SmsT_H;
                // this.smsSetting[1].disconnect = response.data.receiver2SmsBeat;
                // this.smsSetting[1].power = response.data.receiver2SmsPower;

                // this.smsSetting[2].phoneNumber =
                //   response.data.receiver3SimCartNumber;
                // this.smsSetting[2].active = response.data.receiver3Beat;

                // this.smsSetting[2].text = response.data.receiver3SmsText;
                this.smsSetting[2].firstSmsDelay =
                  response.data.receiver3FirstAlarmSmsTimer;
                this.smsSetting[2].secondSmsDelay =
                  response.data.receiver3NextAlarmSmsTimer;
                // this.smsSetting[2].tempHum = response.data.receiver3SmsT_H;
                // this.smsSetting[2].disconnect = response.data.receiver3SmsBeat;
                // this.smsSetting[2].power = response.data.receiver3SmsPower;

                // this.smsSetting[3].phoneNumber =
                //   response.data.receiver4SimCartNumber;
                // this.smsSetting[3].active = response.data.receiver4Beat;

                // this.smsSetting[3].text = response.data.receiver4SmsText;
                this.smsSetting[3].firstSmsDelay =
                  response.data.receiver4FirstAlarmSmsTimer;
                this.smsSetting[3].secondSmsDelay =
                  response.data.receiver4NextAlarmSmsTimer;
                // this.smsSetting[3].tempHum = response.data.receiver4SmsT_H;
                // this.smsSetting[3].disconnect = response.data.receiver4SmsBeat;
                // this.smsSetting[3].power = response.data.receiver4SmsPower;

                // this.smsSetting[4].phoneNumber =
                //   response.data.receiver5SimCartNumber;
                // this.smsSetting[4].active = response.data.receiver5Beat;

                // this.smsSetting[4].text = response.data.receiver5SmsText;
                this.smsSetting[4].firstSmsDelay =
                  response.data.receiver5FirstAlarmSmsTimer;
                this.smsSetting[4].secondSmsDelay =
                  response.data.receiver5NextAlarmSmsTimer;
                // this.smsSetting[4].tempHum = response.data.receiver5SmsT_H;
                // this.smsSetting[4].disconnect = response.data.receiver5SmsBeat;
                // this.smsSetting[4].power = response.data.receiver5SmsPower;

                // this.smsSetting[5].phoneNumber =
                //   response.data.receiver6SimCartNumber;
                // this.smsSetting[5].active = response.data.receiver6Beat;

                // this.smsSetting[5].text = response.data.receiver6SmsText;
                this.smsSetting[5].firstSmsDelay =
                  response.data.receiver6FirstAlarmSmsTimer;
                this.smsSetting[5].secondSmsDelay =
                  response.data.receiver6NextAlarmSmsTimer;
                // this.smsSetting[5].tempHum = response.data.receiver6SmsT_H;
                // this.smsSetting[5].disconnect = response.data.receiver6SmsBeat;
                // this.smsSetting[5].power = response.data.receiver6SmsPower;
                this.smsUpdateTimeDelay =
                  response.data.receiversAlarmSmsTimerInformationLastUpdateDateTimeJalali;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (data == "sensorTempHum") {
        var forms = document.querySelectorAll(
          ".needs-validationsensorTempHumFE22WE"
        );
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          console.log(deviceId);
          console.log(sensorId);
          axios
            .post(
              Values.serverIp +
                "FE22WEDeviceSetting/GetTemperatureSensorsSettingValue",
              {
                deviceId: deviceId,

                sensorIndex: this.sensorSetting.sensorIndex.value,
                receiver1TemperatureHigh: this.sensorTempHumSetting[0].tempUp,
                receiver1TemperatureLow: this.sensorTempHumSetting[0].tempDown,

                receiver2TemperatureHigh: this.sensorTempHumSetting[1].tempUp,
                receiver2TemperatureLow: this.sensorTempHumSetting[1].tempDown,

                receiver3TemperatureHigh: this.sensorTempHumSetting[2].tempUp,
                receiver3TemperatureLow: this.sensorTempHumSetting[2].tempDown,

                receiver4TemperatureHigh: this.sensorTempHumSetting[3].tempUp,
                receiver4TemperatureLow: this.sensorTempHumSetting[3].tempDown,

                receiver5TemperatureHigh: this.sensorTempHumSetting[4].tempUp,
                receiver5TemperatureLow: this.sensorTempHumSetting[4].tempDown,

                receiver6TemperatureHigh: this.sensorTempHumSetting[5].tempUp,
                receiver6TemperatureLow: this.sensorTempHumSetting[5].tempDown,

                receiver1HumidityHigh: this.sensorTempHumSetting[0].humUp,
                receiver1HumidityLow: this.sensorTempHumSetting[0].humDwon,

                receiver2HumidityHigh: this.sensorTempHumSetting[1].humUp,
                receiver2HumidityLow: this.sensorTempHumSetting[1].humDwon,

                receiver3HumidityHigh: this.sensorTempHumSetting[2].humUp,
                receiver3HumidityLow: this.sensorTempHumSetting[2].humDwon,

                receiver4HumidityHigh: this.sensorTempHumSetting[3].humUp,
                receiver4HumidityLow: this.sensorTempHumSetting[3].humDwon,

                receiver5HumidityHigh: this.sensorTempHumSetting[4].humUp,
                receiver5HumidityLow: this.sensorTempHumSetting[4].humDwon,

                receiver6HumidityHigh: this.sensorTempHumSetting[5].humUp,
                receiver6HumidityLow: this.sensorTempHumSetting[5].humDwon,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                this.sensorTempHumSetting[0].tempUp =
                  response.data.receiver1TemperatureHigh;
                this.sensorTempHumSetting[0].tempDown =
                  response.data.receiver1TemperatureLow;

                this.sensorTempHumSetting[1].tempUp =
                  response.data.receiver2TemperatureHigh;
                this.sensorTempHumSetting[1].tempDown =
                  response.data.receiver2TemperatureLow;

                this.sensorTempHumSetting[2].tempUp =
                  response.data.receiver3TemperatureHigh;
                this.sensorTempHumSetting[2].tempDown =
                  response.data.receiver3TemperatureLow;

                this.sensorTempHumSetting[3].tempUp =
                  response.data.receiver4TemperatureHigh;
                this.sensorTempHumSetting[3].tempDown =
                  response.data.receiver4TemperatureLow;

                this.sensorTempHumSetting[4].tempUp =
                  response.data.receiver5TemperatureHigh;
                this.sensorTempHumSetting[4].tempDown =
                  response.data.receiver5TemperatureLow;

                this.sensorTempHumSetting[5].tempUp =
                  response.data.receiver6TemperatureHigh;
                this.sensorTempHumSetting[5].tempDown =
                  response.data.receiver6TemperatureLow;

                this.sensorTempHumUpdateTime =
                  response.data.temperatureInformationLastUpdateDateTimeJalali;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (data == "sensorTempHum_hum") {
        var forms = document.querySelectorAll(
          ".needs-validationsensorTempHumFE22WE"
        );
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          console.log(deviceId);
          console.log(sensorId);
          axios
            .post(
              Values.serverIp +
                "FE22WEDeviceSetting/GetHumiditySensorsSettingValue",
              {
                deviceId: deviceId,

                sensorIndex: this.sensorSetting.sensorIndex.value,
                receiver1TemperatureHigh: this.sensorTempHumSetting[0].tempUp,
                receiver1TemperatureLow: this.sensorTempHumSetting[0].tempDown,

                receiver2TemperatureHigh: this.sensorTempHumSetting[1].tempUp,
                receiver2TemperatureLow: this.sensorTempHumSetting[1].tempDown,

                receiver3TemperatureHigh: this.sensorTempHumSetting[2].tempUp,
                receiver3TemperatureLow: this.sensorTempHumSetting[2].tempDown,

                receiver4TemperatureHigh: this.sensorTempHumSetting[3].tempUp,
                receiver4TemperatureLow: this.sensorTempHumSetting[3].tempDown,

                receiver5TemperatureHigh: this.sensorTempHumSetting[4].tempUp,
                receiver5TemperatureLow: this.sensorTempHumSetting[4].tempDown,

                receiver6TemperatureHigh: this.sensorTempHumSetting[5].tempUp,
                receiver6TemperatureLow: this.sensorTempHumSetting[5].tempDown,

                receiver1HumidityHigh: this.sensorTempHumSetting[0].humUp,
                receiver1HumidityLow: this.sensorTempHumSetting[0].humDwon,

                receiver2HumidityHigh: this.sensorTempHumSetting[1].humUp,
                receiver2HumidityLow: this.sensorTempHumSetting[1].humDwon,

                receiver3HumidityHigh: this.sensorTempHumSetting[2].humUp,
                receiver3HumidityLow: this.sensorTempHumSetting[2].humDwon,

                receiver4HumidityHigh: this.sensorTempHumSetting[3].humUp,
                receiver4HumidityLow: this.sensorTempHumSetting[3].humDwon,

                receiver5HumidityHigh: this.sensorTempHumSetting[4].humUp,
                receiver5HumidityLow: this.sensorTempHumSetting[4].humDwon,

                receiver6HumidityHigh: this.sensorTempHumSetting[5].humUp,
                receiver6HumidityLow: this.sensorTempHumSetting[5].humDwon,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                this.sensorTempHumSetting[0].humUp =
                  response.data.receiver1HumidityHigh;
                this.sensorTempHumSetting[0].humDwon =
                  response.data.receiver1HumidityLow;

                this.sensorTempHumSetting[1].humUp =
                  response.data.receiver1HumidityHigh;
                this.sensorTempHumSetting[1].humDwon =
                  response.data.receiver1HumidityLow;

                this.sensorTempHumSetting[2].humUp =
                  response.data.receiver3HumidityHigh;
                this.sensorTempHumSetting[2].humDwon =
                  response.data.receiver3HumidityLow;

                this.sensorTempHumSetting[3].humUp =
                  response.data.receiver4HumidityHigh;
                this.sensorTempHumSetting[3].humDwon =
                  response.data.receiver4HumidityLow;

                this.sensorTempHumSetting[4].humUp =
                  response.data.receiver5HumidityHigh;
                this.sensorTempHumSetting[4].humDwon =
                  response.data.receiver5HumidityLow;

                this.sensorTempHumSetting[5].humUp =
                  response.data.receiver6HumidityHigh;
                this.sensorTempHumSetting[5].humDwon =
                  response.data.receiver6HumidityLow;

                this.sensorTempHumUpdateTime =
                  response.data.temperatureInformationLastUpdateDateTimeJalali;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (data == "sensor") {
        var forms = document.querySelectorAll(".needs-validationSensorFE22WE");
        let formValid = true;

        if (!formValid) {
          // console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          let settingValuesSensor = [];

          for (var i = 0; i < this.sensorSetting.alarmRelay.length; i++) {
            settingValuesSensor.push({
              sensorType: this.sensorSetting.alarmRelay[i].type,
              validHighLimit:
                this.sensorSetting.alarmRelay[i].relayUp == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].relayUp,
              validLowLimit:
                this.sensorSetting.alarmRelay[i].relayDown == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].relayDown,
              alarmHighLimit:
                this.sensorSetting.alarmRelay[i].alarmDown == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].alarmDown,
              alarmLowLimit:
                this.sensorSetting.alarmRelay[i].alarmDown == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].alarmDown,
              calibration:
                this.sensorSetting.alarmRelay[i].collibrartion == ""
                  ? null
                  : this.sensorSetting.alarmRelay[i].collibrartion,
            });
          }

          axios
            .post(
              Values.serverIp + "FE22WEDeviceSetting/GetSensorsSettingValue",
              {
                deviceId: deviceId,
                // sensor
                sensorIndex: sensorId,
                sensorTypeRegister: this.sensorSetting.type.value,
                sensorEnable: this.sensorSetting.active,
                sensorValuesList: settingValuesSensor,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                console.log(response.data);

                if (response.data.sensorValuesList[0].sensorType == 1) {
                  this.sensorSetting.alarmRelay = [
                    {
                      name: "دما",
                      relayUp: response.data.sensorValuesList[0].validHighLimit,
                      relayDown:
                        response.data.sensorValuesList[0].validLowLimit,
                      alarmUp: response.data.sensorValuesList[0].alarmHighLimit,
                      alarmDown:
                        response.data.sensorValuesList[0].alarmLowLimit,
                      collibrartion:
                        response.data.sensorValuesList[0].calibration,
                    },
                    {
                      name: "رطوبت",
                      relayUp: response.data.sensorValuesList[1].validHighLimit,
                      relayDown:
                        response.data.sensorValuesList[1].validLowLimit,
                      alarmUp: response.data.sensorValuesList[1].alarmHighLimit,
                      alarmDown:
                        response.data.sensorValuesList[1].alarmLowLimit,
                      collibrartion:
                        response.data.sensorValuesList[1].calibration,
                    },
                  ];
                } else {
                  this.sensorSetting.alarmRelay = [
                    {
                      name: "دما",
                      relayUp: response.data.sensorValuesList[1].validHighLimit,
                      relayDown:
                        response.data.sensorValuesList[1].validLowLimit,
                      alarmUp: response.data.sensorValuesList[1].alarmHighLimit,
                      alarmDown:
                        response.data.sensorValuesList[1].alarmLowLimit,
                      collibrartion:
                        response.data.sensorValuesList[1].calibration,
                    },
                    {
                      name: "رطوبت",
                      relayUp: response.data.sensorValuesList[0].validHighLimit,
                      relayDown:
                        response.data.sensorValuesList[0].validLowLimit,
                      alarmUp: response.data.sensorValuesList[0].alarmHighLimit,
                      alarmDown:
                        response.data.sensorValuesList[0].alarmLowLimit,
                      collibrartion:
                        response.data.sensorValuesList[0].calibration,
                    },
                  ];
                }

                (this.sensorSetting.active = response.data.sensorEnable),
                  this.setSensorType(response.data.sensorTypeRegister);
                this.sensorRelayAlarmUpdateTime =
                  response.data.sensorInformationLastUpdateDateTimeJalali;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },

    //********************************************************************* set Simcard Oprator */
    setSimcardOprator(data) {
      for (var i = 0; i < this.SimcardOpratorList.length; i++) {
        if (this.SimcardOpratorList[i].id == data) {
          this.SimcardOprator = this.SimcardOpratorList[i];
        }
      }
    },

    //********************************************************************* set Sensor Type */
    setSensorType(data) {
      for (var i = 0; i < this.typeList.length; i++) {
        if (this.typeList[i].value == data) {
          this.sensorSetting.type = this.typeList[i];
        }
      }
    },
    // *****************************************************************restore Default
    restoreDefault() {
      // make all part to enabled
      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );

      // clear all red borders
      $(
        ".form-control, .needs-validationSimFE22WE > .multiselect__tags"
      ).removeAttr("style");

      $(
        ".form-control, .needs-validationSensorFE22WE > .multiselect__tags"
      ).removeAttr("style");

      this.alert = false;

      (this.ethernet = {
        ipAddress: "",
        subnetMask: "",
        gateway: "",
        dns: "",
        updateTime: "---",
      }),
        (this.logInfo = { distance: "", updateTime: "---" }),
        (this.voiceAlarmInfo = {
          delay: "",
          length: "",
          voiceTemp: false,
          smsTemp: false,
          voiceHum: false,
          smsHum: false,
          updateTime: "---",
        });

      this.serverInfo = {
        ipAddressGPRS: "",
        ipAddressEthernet: "",
        ipAddressWifi: "",
        port: "",
        timeDistance: "",
        debugEth: false,
        debugWifi: false,
        debugGprs: false,
        ethernet: false,
        gprs: false,
        wifi: false,
        updateTime: "---",
        atWifi: false,
        atGprs: false,
      };

      this.pulsInfo = {
        first: "",
        second: "",
        updateTime: "---",
      };

      this.dateTime = { dateTime: "", updateTime: "" };

      (this.serial = { serialTime: "", serialNumber: "" }),
        (this.SimcardOprator = []);
      this.simcardUpdateTime = "---";

      this.smsSetting = [
        {
          name: "گیرنده اول",
          phoneNumber: "",
          active: false,
          text: false,
          tempHum: false,
          disconnect: false,
          power: false,
          firstSmsDelay: 0,
          secondSmsDelay: 0,
        },
        {
          name: "گیرنده دوم",
          phoneNumber: "",
          active: false,
          text: false,
          tempHum: false,
          disconnect: false,
          power: false,
          firstSmsDelay: 0,
          secondSmsDelay: 0,
        },

        {
          name: "گیرنده سوم",
          phoneNumber: "",
          active: false,
          text: false,
          tempHum: false,
          disconnect: false,
          power: false,
          firstSmsDelay: 0,
          secondSmsDelay: 0,
        },
        {
          name: "گیرنده چهارم",
          phoneNumber: "",
          active: false,
          text: false,
          tempHum: false,
          disconnect: false,
          power: false,
          firstSmsDelay: 0,
          secondSmsDelay: 0,
        },
        {
          name: "گیرنده پنجم",
          phoneNumber: "",
          active: false,
          text: false,
          tempHum: false,
          disconnect: false,
          power: false,
          firstSmsDelay: 0,
          secondSmsDelay: 0,
        },
        {
          name: "گیرنده ششم",
          phoneNumber: "",
          active: false,
          text: false,
          tempHum: false,
          disconnect: false,
          power: false,
          firstSmsDelay: 0,
          secondSmsDelay: 0,
        },
      ];
      this.smsUpdateTime = "---";
      this.smsUpdateTimeFlag = "---";
      this.smsUpdateTimeDelay = "---";
      this.sensorTempHumSetting = [
        {
          name: "گیرنده اول",
          tempUp: null,
          tempDown: null,
          humUp: null,
          humDwon: null,
        },
        {
          name: "گیرنده دوم",
          tempUp: null,
          tempDown: null,
          humUp: null,
          humDwon: null,
        },
        {
          name: "گیرنده سوم",
          tempUp: null,
          tempDown: null,
          humUp: null,
          humDwon: null,
        },
        {
          name: "گیرنده چهارم",
          tempUp: null,
          tempDown: null,
          humUp: null,
          humDwon: null,
        },
        {
          name: "گیرنده پنجم",
          tempUp: null,
          tempDown: null,
          humUp: null,
          humDwon: null,
        },
        {
          name: "گیرنده ششم",
          tempUp: null,
          tempDown: null,
          humUp: null,
          humDwon: null,
        },
      ];
      this.sensorTempHumUpdateTime = "---";

      this.sensorSetting = {
        sensorIndex: { label: "سنسور اول", value: 1 },
        active: false,
        type: [],
        alarmRelay: [
          {
            name: "دما",
            relayUp: "",
            relayDown: "",
            alarmUp: "",
            alarmDown: "",
            collibrartion: "",
          },
          {
            name: "روطوبت",
            relayUp: "",
            relayDown: "",
            alarmUp: "",
            alarmDown: "",
            collibrartion: "",
          },
        ],
      };
      this.sensorRelayAlarmUpdateTime = "---";
    },
  },
};
</script>

<style>
</style>

<style lang="css">
/* time picker style (start) */
.clock-picker__input {
  border: 1px solid gainsboro;
}
.clock-picker__input--error,
.clock-picker__input--error.clock-picker__input--has-value {
  color: #f44336;
}
.clock-picker__input--error .clock-picker__input,
.clock-picker__input--error.clock-picker__input--has-value
  .clock-picker__input {
  border-color: #f44336;
}
.clock-picker__input--has-value .clock-picker__input {
  border-color: #bec0c0;
}
.clock-picker__button {
  background: none;
  width: 24px;
  height: 24px;
  display: inline-block;
  border: 0;
  border-radius: 12px;
  line-height: 24px;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #757575;
  font-weight: 500;
  font-size: 13px;
}
.clock-picker__button:hover {
  background-color: #f5f5f5;
}
.clock-picker__button:active {
  background-color: #ededed;
}
.clock-picker__button:focus {
  background-color: #e8e8e8;
}
.clock-picker__button--active,
.clock-picker__button--active:active,
.clock-picker__button--active:hover,
.clock-picker__button--active:focus {
  background-color: #a48bd1;
  color: #fff;
}
.clock-picker__button[disabled] {
  opacity: 0.4 !important;
  cursor: default;
}
.clock-picker__button[disabled],
.clock-picker__button[disabled]:active,
.clock-picker__button[disabled]:hover,
.clock-picker__button[disabled]:focus {
  background-color: #f5f5f5;
  color: #757575;
}

.clock-picker__dialog {
  display: none;
}
.clock-picker__dialog--active {
  display: block;
}
.clock-picker__dialog-drop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 200;
}
.clock-picker__dialog-body {
  direction: ltr;
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
  width: 320px;
  margin: -235px -160px;
  background-color: #fff;
  z-index: 201;
  transform: scale(1);
  border-radius: 5px;
  overflow: auto;
}
.clock-picker__dialog-header {
  padding: 1.5rem 1.5rem;
  font-size: 2rem;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.clock-picker__dialog-header span:hover,
.clock-picker__dialog-header span:focus {
  cursor: pointer;
}
.clock-picker__dialog-content {
  position: relative;
  width: 100%;
  height: 280px;
  margin-top: 24px;
  margin-bottom: 24px;
}
.clock-picker__dialog-content .clock-picker__hours,
.clock-picker__dialog-content .clock-picker__minutes {
  position: absolute;
}
.clock-picker__dialog-actions {
  direction: rtl;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: row;
  flex-direction: row;
  border-top: 1px solid #f5f5f5;
  padding: 0.5rem;
}
.clock-picker__dialog-action {
  padding: 0 1rem;
  margin: 0;
  background: transparent;
  border: 0;
  -ms-flex: 1;
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  line-height: 32px;
  display: inline-block;
  cursor: pointer;
}
.clock-picker__dialog-action:hover {
  background-color: #f5f5f5;
}
.clock-picker__dialog-action:focus {
  background-color: #ededed;
}
.clock-picker__dialog-action:active {
  background-color: #e6e6e6;
}
.clock-picker__dialog-action[disabled] {
  background-color: #f5f5f5;
  color: #e6e6e6;
}
.clock-picker__dialog-action[disabled]:hover,
.clock-picker__dialog-action[disabled]:focus,
.clock-picker__dialog-action[disabled]:active {
  cursor: not-allowed;
}
.clock-picker__dialog .scale-enter-active,
.clock-picker__dialog .scale-leave-active,
.clock-picker__dialog .fade-enter-active,
.clock-picker__dialog .fade-leave-active {
  transition: all 0.3s ease;
}
.clock-picker__dialog .scale-enter,
.clock-picker__dialog .scale-leave-active {
  opacity: 0;
  transform: scale(0);
}
.clock-picker__dialog .fade-enter,
.clock-picker__dialog .fade-leave-active {
  opacity: 0;
}

.clock-picker__hours {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 280px;
}

.clock-picker__minutes {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 280px;
}

/* add by alireza */
.clock-picker__input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

.clock-picker__dialog-action[type="button"] {
  color: #39f !important;
}
.clock-picker__dialog-header {
  background-color: #39f !important;
}
/* time picker style (end) */
</style>
